import {
  Box,
  IconButton,
  Link,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme
} from "@mui/material";

import {
  Chip
} from "@mui/material";

import {
  AssignmentOutlined,
  AssignmentReturnedOutlined,
  AssignmentTurnedInOutlined,
  BoltOutlined,
  CalendarTodayOutlined,
  CommentOutlined,
  Create,
  DescriptionOutlined,
  HistoryOutlined,
  InfoOutlined,
  KeyboardArrowDown,
  LocalShippingOutlined,
  ModeOutlined,
  NoteAddOutlined,
  PersonOutlined,
  PictureAsPdfOutlined,
  ReceiptLongOutlined,
  RemoveShoppingCartOutlined,
  ReplayOutlined,
  SyncOutlined,
  TrackChanges,
  TrendingUpOutlined,
  TroubleshootOutlined,
  UTurnLeftOutlined,
  WallpaperOutlined
} from "@mui/icons-material";
import { Menu, MenuItem } from "@mui/material";
import Alert from "@mui/material/Alert";
import dayjs from "dayjs";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { AUDIT_ENTITYS, CAN_ACCESS_APPLICATION, ORDER_ACTIONS, ORDER_AVAILABILITY, ORDER_DETAILS_BUTTONS, ORDER_STATUS, ORDERTYPE, PRODUCT_CATEGORY, PRODUCT_STATUS, USER_ROLE_ENTITY_NAMES, USER_ROLES } from "../../../constants/applicationConstants";
import { useNavigation } from "../../../hooks/useNavigation";
import { selectIsTokenAvailable, selectIsValueFoundInToken, setSelectedModule, useAuthSlice } from "../../../redux/slice/authSlice";
import { setSingleAlertObj, SingleAlertInfo } from "../../../redux/slice/commonSlice";
import {
  cancelOrder,
  fetchOrderById,
  fetchOrderDocumentById,
  fetchOrderDocumentsByIds,
  fetchProductReturnAuditById,
  getOrderItemsByOrderId,
  getOrderTrackingLogs,
  OrderFulfillmentInfo,
  OrderInfo,
  OrderItemDTO,
  orderItemInvoice,
  OrderItemsPriceUpdateRequest,
  previewCMSPDF,
  previewEvaltionForm,
  previewPackagePDF,
  previewPrescriptionPDF,
  previewProofOfDelivery,
  previewSalesPDF,
  resetOrderDocumentInfo,
  resetOrderItemListInfo,
  TissueTrackingDetail,
  updateOrder,
  updateOrderItemsPrice,
  useOrderSlice,
  hasOutsideOrderItemPayment,
} from "../../../redux/slice/order/OrderSlice";
import { getPatient } from "../../../redux/slice/patient/patientSlice";
import { getProductItemkitItemByIds } from "../../../redux/slice/product/createProductSlice";
import { saveProviderSignAgainstOrder } from "../../../redux/slice/providerNotifications/ProviderNotificationSlice";
import { useAppDispatch } from "../../../redux/slice/redux-hooks";
import { getSalesDetailsByOrderId, useSaleDetailsSlice } from "../../../redux/slice/saleDetails/SaleDetailsSlice";
import { RootState } from "../../../redux/store";
import { SUCCESS_CODE } from "../../../service/ServiceConstants";
import { tokens } from "../../../theme";
import { formatShippingTrackingDateTime, hideElement, priceFormatter } from "../../../utils/Utility";
import { buildActivityCenterPath } from "../../../utils/activityCenterUtils";
import { ActionItem } from "../../common/ActionMenu";
import Button from "../../common/Button";
import PageBackButton from "../../common/PageBackButton";
import CustomCheckbox from "../../common/CustomCheckBox";
import CustomCommentPopup from "../../common/CustomCommentPopup";
import CustomIconButton from "../../common/CustomIconButton";
import CustomTextField from "../../common/CustomTextField";
import OptionsPopup from "../../common/OptionsPopup";
import PDFViewer from "../../common/pdf/PDFViewer";
import {
  UpfrontOrderDetailsNote
} from "../../common/UpfrontPriceBreakdown";
import { SectionHeader } from "../../ui/ContentSection";
import { useModalStyles } from "../../common/useModalStyles";
import EditOrderAmountPopup from "./EditOrderAmountPopup";
import ExcelDetailsPopup from "./ExcelDetailsPopup";
import ReturnAuditPopup, { ProductReturnTracking } from "./ReturnAuditPopup";
import ShipmentInfoPopup from "./ShipmentInfoPopup";
import SigantureSubmitPopup from "./SignatureSubmitPopup";
import SignOrderPopup from "./SignOrderPopup";

interface Column {
  id: string;
  label: string;
  minWidth?: number;
  align?: "right" | "center" | "left";
  format?: (value: number) => string;
}

interface Row {
  select: any;
  orderedGrafts: string;
  serialNumber: string;
  id: number;
  tissueTrackingId: number;
  productReturnId: number;
  productReturnStatus: string;
  orderStatus: string;
  comment: string;
  returnRequestComments?: string;
  tissueTrackingDocumentId: number;
  tissueTrackingInfo: {
    barcodes: number[];
    imagesOfWounds: number[];
    medicalNotes: number[];
  };
  returnDocumentId: number;
  returnRejectDocId?: number;
  returnPendingDocId?: number;
  invoice: orderItemInvoice;
  invoiceId: number;
  uploadedProductPackageIds: number[];
  appRetDate: string | JSX.Element;
  invoiceDate: string | JSX.Element;
  productItemId: number;
}

const Details = ({
  embedded = false,
  orderIdOverride,
}: {
  /** When true, hide page Back/title — parent (e.g. Finance HQ) already provides chrome. */
  embedded?: boolean;
  /** Prefer this id when hosted outside /details/:id route (same component, no fork). */
  orderIdOverride?: number;
} = {}) => {
  const { control, setValue, getValues } = useForm<TissueTrackingDetail>({
    defaultValues: {
      patient: "",
      product: "",
      order: "",
      po: "",
      dateOfService: "",
      shippingCarrier: "",
      trackingNumber: "",
      orderStatus: "",
      providerName: "",
      practiceName: "",
    },
  });

  const { navigate } = useNavigation();
  const location = useLocation();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const { tokens: mTokens, isDark: isDarkModal, backBtnSx: backBtnStyleSx, iconBoxSx: mIconBoxSx } = useModalStyles();
  const dispatch = useAppDispatch();
  const [order, setOrder] = useState<OrderInfo>();
  const { orderItemsListInfo, orderDocumentInfo, orderTrackingLogs, OrderObject } = useOrderSlice();
  const [showCommentPopup, setShowCommentPopup] = useState(false);
  const [showReturnPopup, setShowReturnPopup] = useState(false);
  const [commentData, setCommentData] = useState<{ title: string; body: string }>({
    title: "",
    body: "",
  });
  const [returnAuditData, setReturnAuditData] = useState<ProductReturnTracking | null>(null);

  const [showCommentAlert, setShowCommentAlert] = useState(false);
  const [comment, setComment] = useState("");
  const [selectedRowId, setSelectedRowId] = useState<string | null>(null);
  const [showPDF, setShowPDF] = useState<{
    isShow: boolean;
    productName: string;
    fileName: string;
  }>({ isShow: false, productName: "", fileName: "" });
  const [serialNumbers, setSerialNumbers] = useState<{ [key: number]: string }>(
    {}
  );
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [mfrPatientId, setMfrPatientId] = useState<string>("");

  const [shipmentInfoOpen, setShipmentInfoOpen] = useState(false);
    const [kitItemsMap, setKitItemsMap] = useState<Record<number, any[]>>({});


  const parsedTrackingInfo = orderTrackingLogs?.detailedTrackingInfo
    ? JSON.parse(orderTrackingLogs.detailedTrackingInfo)
    : null;

  const trackingData = parsedTrackingInfo?.track_info;

  const scanEvents = trackingData?.tracking?.providers[0]?.events || [];
  const dateAndTimes = trackingData?.milestone || [];
  const shippingDateRaw = dateAndTimes.find((d: any) => d.key_stage === "InfoReceived")?.time_iso;
  const departureTimeRaw = dateAndTimes.find((d: any) => d.key_stage === "PickedUp")?.time_iso;
  const timeMetrics = trackingData?.time_metrics;
  const shippingDate = formatShippingTrackingDateTime(shippingDateRaw);
  const departureTime = formatShippingTrackingDateTime(departureTimeRaw);
  const expectedArrivalFrom = formatShippingTrackingDateTime(timeMetrics?.estimated_delivery_date?.from);
  const expectedArrivalTo = formatShippingTrackingDateTime(timeMetrics?.estimated_delivery_date?.to);
  const deliveryEvent = scanEvents.find((event: any) => event.stage === "Delivered");
  const actualDeliveryTime = formatShippingTrackingDateTime(deliveryEvent?.time_iso);
  const canAccessSalesInvoice = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessOrderDetailsActionButton", ORDER_DETAILS_BUTTONS.SALES_INVOICE)(state));

  const canAccessApplication = useSelector((state: RootState) =>
    selectIsValueFoundInToken(
      "canAccessApplication",
      CAN_ACCESS_APPLICATION.INVOICE_MANAGEMENT
    )(state)
  );

  const canViewCOGSPrice = useSelector((state: RootState) => selectIsValueFoundInToken("canViewCOGSPrice", CAN_ACCESS_APPLICATION.ORDER_MANAGEMENT)(state));
  //CS-1302 - Start
  const canSignOrder = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessOrderActions", ORDER_ACTIONS.SIGNORDER)(state));
  const [showSignatureSubmitPopup, setShowSignatureSubmitPopup] = useState<boolean>(false);
  //CS-1302 - End
  const canUpdateOrderItemPrice = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessOrderActions", ORDER_ACTIONS.UPDATE)(state));
  const isNotPlacedOrCanceled = !(order?.orderStatus === PRODUCT_STATUS.PLACED || order?.orderStatus === PRODUCT_STATUS.CANCELED);
  const isProcessing = order?.orderStatus === PRODUCT_STATUS.PROCESSING;
  const isShipped = order?.orderStatus === PRODUCT_STATUS.SHIPPED;
  const isDelivered = order?.orderStatus === PRODUCT_STATUS.DELIVERED;

  const [isEditing, setIsEditing] = useState(false);
  const [poNumberValue, setPoNumberValue] = useState<string>(order?.poNumber || getValues("po") || "");
  const [documentsMenuAnchor, setDocumentsMenuAnchor] = useState<null | HTMLElement>(null);
  const [actionMenuAnchor, setActionMenuAnchor] = useState<null | HTMLElement>(null);
  const { SalesDetailsInfo } = useSaleDetailsSlice();
  const [showExcelPopup, setShowExcelPopup] = useState(false);
  const { userInfo } = useAuthSlice();
  const canViewExcelData = useSelector((state: RootState) => selectIsTokenAvailable("canViewExcelData")(state));
  const canFulfilOrder = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessOrderActions", ORDER_ACTIONS.FULFILL)(state));
  const canManageReturn = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessOrderActions", ORDER_ACTIONS.MANAGE_RETURN)(state));
  const canBillOrder = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessOrderActions", ORDER_ACTIONS.BILLING)(state));
  const canReOrder = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessOrderActions", ORDER_ACTIONS.REORDER)(state));
  const canCancelOrder = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessOrderActions", ORDER_ACTIONS.CANCEL)(state));
  const canAuditOrder = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessAuditAction", AUDIT_ENTITYS.USERAUDIT)(state));
  const canTrackOrder = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessOrderActions", ORDER_ACTIONS.TRACKING)(state));
  const canReturnOrder = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessOrderActions", ORDER_ACTIONS.RETURN)(state));
  const canAccessActivityCenter = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessOrderActions", ORDER_ACTIONS.ACTIVITY_CENTER)(state));

  const [isConfirmationOpen, setIsConfirmationOpen] = useState<boolean>(false);
  const [showSignOrderPopup, setShowSignOrderPopup] = useState<boolean>(false);
  const [showEditAmountPopup, setShowEditAmountPopup] = useState<boolean>(false);

  const redirectToTheOrderFulfillment = () => {
    const fulfillDetails = {
      ...OrderObject,
      trackingNumber: OrderObject?.trackingNumber || order?.trackingNumber || null,
    };
    navigate("/fulfill_order", { state: { selectedOrderDetail: fulfillDetails } });
  };

  const handleManageReturn = () => {
    navigate("/manage_return", { state: { selectedReturnRequest: OrderObject } });
  };

  const handleBilling = () => {
    navigate("/billing", { state: { selectedOrderBilling: OrderObject } });
  };

  const handleCreateInvoice = () => {
    navigate("/create_invoice", { state: { selectedOrderBilling: OrderObject } });
  };

  const handleCancelAndReOrder = () => {
    const reorderDetails = {
      ...OrderObject,
      dateOfService: OrderObject?.dateOfService ?? order?.dateOfService ?? null,
      requestedDeliveryDate: OrderObject?.requestedDeliveryDate ?? order?.requestedDeliveryDate ?? null,
      poNumber: OrderObject?.poNumber ?? order?.poNumber ?? null,
    };
    navigate("/order", {
      state: {
        orderType: ORDERTYPE.DIRECT_ORDER,
        orderDetails: reorderDetails,
        isReorder: true,
        orderDate: reorderDetails.orderDate,
      },
    });
  };

  const isOutsideOrder =
    OrderObject?.isOutsideOrder === true ||
    OrderObject?.orderInfo?.isOutsideOrder === true ||
    OrderObject?.orderInfo?.isOutsideOrder === "true" ||
    order?.isOutsideOrder === true ||
    order?.orderInfo?.isOutsideOrder === true ||
    order?.orderInfo?.isOutsideOrder === "true";
    
  const canUpdateOutsideOrder =
    isOutsideOrder &&
    !hasOutsideOrderItemPayment(OrderObject ?? order);

  const isManualProduct =
    OrderObject?.orderInfo?.productEntryType === "MANUAL" ||
    order?.orderInfo?.productEntryType === "MANUAL";

  const handleEditOutsideOrder = () => {
    const orderId = OrderObject?.orderId ?? order?.orderId;
    if (!orderId) return;

    navigate("/order", {
      state: {
        orderType: ORDERTYPE.PAST_ORDER,
        outsideOrderEditOrderId: orderId,
      },
    });
  };

  const handleNavigate = () => {
    if (OrderObject?.orderType === ORDERTYPE.CONSIGNMENT_ORDER) {
      navigate("/create_consignment_order", { state: { selectedOrder: OrderObject } });
    } else {
      navigate("/tissue_tracking", { state: { selectedOrder: OrderObject } });
    }
  };

  const handleCancelOrder = async () => {
    setIsConfirmationOpen(true);
  };

  const handleCancelOrderConfirmation = async () => {
    if (OrderObject) {
      await dispatch(cancelOrder(OrderObject.orderId))
      await dispatch(fetchOrderById({ orderId: OrderObject.orderId, isSaveAuditLog: true }));
      setIsConfirmationOpen(false);
      navigate("/order_list", {
        state: {
          withSearchHistory: true,
          cancelledOrderNumber: OrderObject.orderNumber,
        },
      });
    }
  };

  const handleCloseCancelOrderConfirmation = () => {
    setIsConfirmationOpen(false);
  };

  const handleClickOrderAudit = () => {
    if (OrderObject && OrderObject.orderNumber) {
      const OrderAuditData = {
        entityName: "ORDER",
        entityNumber: OrderObject?.orderNumber,
      };
      const url = `/auditlog?entityName=${OrderAuditData.entityName}&entityNumber=${OrderAuditData.entityNumber}`;
      window.open(url, "_blank");
      // navigate("/auditlog", { state: { entityName: IVRAuditData.entityName, entityNumber: IVRAuditData.entityNumber } });
    }
  };

  //CS-1564 - Hide the action buttons if the order is inactive only show details and audit
  // Also check OrderObject (fetched via API) to handle navigation from invoice details
  // where location.state may not include inactive date fields
  const hideAllActionsForInactiveOrder =
    (location?.state?.orderDetails?.manufacturerInactiveDate &&
      dayjs(location?.state?.orderDetails?.manufacturerInactiveDate).isBefore(dayjs(), 'day')) || (location?.state?.orderDetails?.productInactiveDate &&
        dayjs(location?.state?.orderDetails?.productInactiveDate).isBefore(dayjs(), 'day')) ||
    (OrderObject?.manufacturerInactiveDate &&
      dayjs(OrderObject.manufacturerInactiveDate).isBefore(dayjs(), 'day')) ||
    (OrderObject?.productInactiveDate &&
      dayjs(OrderObject.productInactiveDate).isBefore(dayjs(), 'day'));

  const showSignOrder =
    order?.customConfig?.provider_signature_required === "Y" &&
    order?.orderStatus === ORDER_STATUS.PENDING &&
    order?.productCategory === PRODUCT_CATEGORY.CONSERVATIVE &&
    canSignOrder &&
    order?.canSignOrder === true;

  const actions: ActionItem[] = [
    {
      label: "Activity Center",
      icon: <HistoryOutlined fontSize="small" />,
      color: "info",
      onClick: () => {
        const source = OrderObject || order;
        const items = orderItemsListInfo || source?.orderItems || [];
        const invoicedItem = items.find((item: any) => item?.invoiceId || item?.mfgInvoiceNumber);
        navigate(buildActivityCenterPath({
          tab: "order",
          orderId: source?.orderId,
          orderNumber: source?.orderNumber,
          invoiceId: source?.invoiceId || invoicedItem?.invoiceId,
          invoiceNumber: invoicedItem?.mfgInvoiceNumber || invoicedItem?.invoice?.mfgInvoiceNumber,
        }));
      },
      isHidden: !canAccessActivityCenter,
    },
    {
      label: "Fulfill",
      icon: <AssignmentTurnedInOutlined fontSize="small" />,
      color: "warning",
      onClick: () => redirectToTheOrderFulfillment(),
      //CS-1717 - Removing inactive product condition
      isHidden: OrderObject?.orderStatus === ORDER_STATUS.PENDING ||
        !(canFulfilOrder && OrderObject?.orderStatus !== ORDER_STATUS.CANCELED && OrderObject?.manufacturerName !== 'Migrate Manufacturer')
    },
    {
      label: "Manage Return",
      icon: <AssignmentReturnedOutlined fontSize="small" />,
      color: "error",
      onClick: () => handleManageReturn(),
      //CS-1717 - Removing inactive product condition
      isHidden: !OrderObject?.orderItems?.some(item => item.productReturnId && (item.productReturnStatus === ORDER_AVAILABILITY.RETURN_INITIATED || item.productReturnStatus === ORDER_AVAILABILITY.RETURN_PENDING)) ||
        !(canManageReturn && OrderObject?.orderStatus !== ORDER_STATUS.CANCELED)
    },
    {
      // CS-1765 - Use top-level purchaseAndBill from order response instead of manufacturer customConfig
      label: OrderObject?.purchaseAndBill !== "Y" ? "Apply INV" : "Create INV",
      icon: <ReceiptLongOutlined fontSize="small" />,
      color: "info",
      onClick: () => OrderObject?.purchaseAndBill !== "Y" ? handleBilling() : handleCreateInvoice(),
      //CS-1717 - Removing inactive product condition
      isHidden: OrderObject?.productCategory === PRODUCT_CATEGORY.CONSERVATIVE ||
        !canBillOrder ||
        ((userInfo?.userRole === USER_ROLES.ROLE_ADMIN || userInfo?.userRole === USER_ROLES.ROLE_SUPERADMIN) ? false : OrderObject?.orderStatus !== ORDER_STATUS.DELIVERED) ||
        OrderObject?.invoiceStatus === "INVOICED" ||
        OrderObject?.manufacturerName === 'Migrate Manufacturer'
    },
    {
      label: "Re-Order",
      icon: <ReplayOutlined fontSize="small" />,
      color: "success",
      onClick: () => handleCancelAndReOrder(),
      isHidden: hideAllActionsForInactiveOrder ||
        OrderObject?.productCategory === PRODUCT_CATEGORY.CONSERVATIVE ||
        !canReOrder ||
        OrderObject?.orderStatus !== ORDER_STATUS.PLACED ||
        OrderObject?.manufacturerName === 'Migrate Manufacturer' ||
        OrderObject?.manufacturerName === 'OP Manufacturer'
    },
    {
      label: "Edit Order",
      icon: <ModeOutlined fontSize="small" />,
      color: "info",
      onClick: () => handleEditOutsideOrder(),
      isHidden: !canUpdateOutsideOrder
    },
    {
      label: "Record Tx",
      icon: <TroubleshootOutlined fontSize="small" />,
      color: "success",
      onClick: () => handleNavigate(),
      //CS-1717 - Removing inactive product condition
      isHidden:OrderObject?.productCategory === PRODUCT_CATEGORY.CONSERVATIVE ||
        !(canTrackOrder && OrderObject?.orderStatus === ORDER_STATUS.DELIVERED)
    },
    {
      label: "Return",
      icon: <UTurnLeftOutlined fontSize="small" />,
      color: "error",
      onClick: () => navigate("/returns", { state: { orderDetails: OrderObject } }),
      //CS-1717 - Removing inactive product condition
      isHidden:OrderObject?.productCategory === PRODUCT_CATEGORY.CONSERVATIVE ||
        !(canReturnOrder && OrderObject?.orderStatus === ORDER_STATUS.DELIVERED) ||
        OrderObject?.manufacturerName === 'Migrate Manufacturer'
    },
    {
      label: "Cancel",
      icon: <RemoveShoppingCartOutlined fontSize="small" />,
      color: "error",
      onClick: () => handleCancelOrder(),
      //CS-1717 - Removing inactive product condition
      isHidden:!canCancelOrder ||
        !(
          OrderObject?.orderStatus === ORDER_STATUS.PLACED ||
          ((userInfo.entityName === USER_ROLE_ENTITY_NAMES.ADMIN && OrderObject?.orderStatus === ORDER_STATUS.PROCESSING && OrderObject?.trackingNumber === null) ||
            (userInfo.entityName === USER_ROLE_ENTITY_NAMES.ADMIN && OrderObject?.orderStatus === ORDER_STATUS.PROCESSING))
        ) ||
        OrderObject?.manufacturerName === 'Migrate Manufacturer'
    },
    {
      label: "Order Audit",
      icon: <TrackChanges fontSize="small" />,
      color: "warning",
      onClick: () => handleClickOrderAudit(),
      isHidden: !canAuditOrder || OrderObject?.manufacturerName === 'Migrate Manufacturer'
    },
    {
      label: "Sign Order",
      icon: <Create fontSize="small" />,
      color: "warning",
      onClick: () => { setShowSignOrderPopup(true) },
      //CS-1717 - Removing inactive product condition
      isHidden:!showSignOrder ||
        OrderObject?.manufacturerName === 'Migrate Manufacturer'
    }
  ];

  const hasVisibleActions = useMemo(() => {
    return actions.some(action => !action.isHidden);
  }, [actions]);

  // Mounting
  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const orderIdFromQuery = query.get("orderId");
    const orderDetails: OrderInfo | undefined = location?.state?.orderDetails;
    const resolvedOrderId =
      orderIdOverride ??
      orderDetails?.orderId ??
      (orderIdFromQuery ? Number(orderIdFromQuery) : undefined);

    if (orderDetails) {
      setOrder(orderDetails);
      setInitialValues(orderDetails);
    }

    if (resolvedOrderId) {
      dispatch(getOrderItemsByOrderId(resolvedOrderId));
      dispatch(getSalesDetailsByOrderId(resolvedOrderId));
      dispatch(fetchOrderById({ orderId: resolvedOrderId, isSaveAuditLog: true }));
    }
  }, [location?.state?.orderDetails, location.search, dispatch, orderIdOverride]);

  useEffect(() => {
    if (location?.state?.orderDetails) return;
    if (!OrderObject?.orderId) return;
    if (orderIdOverride && OrderObject.orderId !== orderIdOverride) return;
    if (!order || order.orderId !== OrderObject.orderId) {
      setOrder(OrderObject);
      setInitialValues(OrderObject);
    }
  }, [OrderObject, location?.state?.orderDetails, order, orderIdOverride]);

  useEffect(() => {
    const oid =
      orderIdOverride ??
      order?.orderId ??
      OrderObject?.orderId ??
      location?.state?.orderDetails?.orderId;
    const trackingNumber =
      order?.trackingNumber ||
      OrderObject?.trackingNumber ||
      location?.state?.orderDetails?.trackingNumber;
    if (!oid || !trackingNumber) return;
    dispatch(
      getOrderTrackingLogs({
        orderId: oid,
        trackingNumber,
      })
    );
  }, [
    dispatch,
    orderIdOverride,
    order?.orderId,
    order?.trackingNumber,
    OrderObject?.orderId,
    OrderObject?.trackingNumber,
    location?.state?.orderDetails?.orderId,
    location?.state?.orderDetails?.trackingNumber,
  ]);

  useEffect(() => {
    const patientId =
      order?.patientId ??
      OrderObject?.patientId ??
      location?.state?.orderDetails?.patientId;
    const manufacturerId =
      order?.manufacturerId ??
      OrderObject?.manufacturerId ??
      location?.state?.orderDetails?.manufacturerId;
    if (!patientId) return;

    const fetchPatientDetails = async () => {
      try {
        const response = await dispatch(getPatient({ patientId: patientId.toString() })).unwrap();
        const updateOrderInfo = response.data.patientInfo?.find((info: { infoType: string; }) => info.infoType === "MANUFACTURER_PATIENT_IDS");

        if (updateOrderInfo && updateOrderInfo.patientinfoData) {
          const manufacturerEntries = Object.values(updateOrderInfo.patientinfoData) as {
            manufacturerId: number;
            manufacturerPatientId: string;
          }[];

          const manufacturerEntry = manufacturerEntries.find(
            (entry) => entry.manufacturerId === manufacturerId
          );

          if (manufacturerEntry) {
            setMfrPatientId(manufacturerEntry.manufacturerPatientId);
          }
        }
      } catch (error) {
        console.error("Error fetching patient details:", error);
      }
    };

    fetchPatientDetails();
  }, [
    dispatch,
    order?.patientId,
    order?.manufacturerId,
    OrderObject?.patientId,
    OrderObject?.manufacturerId,
    location?.state?.orderDetails?.patientId,
    location?.state?.orderDetails?.manufacturerId,
  ]);

  //Unmount — skip when embedded so Finance HQ Summary is not racing a slice clear.
  useEffect(() => () => {
    if (!embedded) {
      dispatch(resetOrderItemListInfo());
    }
    // dispatch(resetCancelStatus());
  }, [embedded]);

  useEffect(() => {
    if (!embedded) {
      dispatch(setSelectedModule("Order"));
    }

    const handleKeyDown = (event: { key: string }) => {
      if (event.key === "Escape") {
        setShowCommentAlert(false);
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const setInitialValues = (orderDetails: OrderInfo) => {
    setValue("order", orderDetails.orderNumber);
    if (orderDetails.patientId) {
      setValue("patient", orderDetails.patientName);
    }
    setValue("product", orderDetails.productName);
    setValue("po", orderDetails.poNumber);
    setValue(
      "dateOfService",
      dayjs(orderDetails.dateOfService).format("MM/DD/YYYY")
    );
    setValue("shippingCarrier", orderDetails.shippingCarrier);
    setValue("trackingNumber", orderDetails.trackingNumber);
    setValue("orderStatus", orderDetails.orderStatus);
    setValue(
      "providerName",
      orderDetails.providerName || orderDetails?.orderInfo?.provider || orderDetails?.provider
    );
    setValue("practiceName", orderDetails.practiceName);
  };

  const getComment = (item: OrderItemDTO) => {
    if (item.tissueTrackingInfo && item.tissueTrackingInfo.comment) {
      return item.tissueTrackingInfo.comment;
    } else if (item?.returnTrackingInfo?.additionalContext) {
      return item.returnTrackingInfo.additionalContext;
    }
    return "";
  };

  const handlePreviewAction = async (row: Row) => {
    let documentId = row.tissueTrackingDocumentId
      ? row.tissueTrackingDocumentId
      : row.returnDocumentId;
    const actionResult = await dispatch(fetchOrderDocumentById(documentId));
    const documentData = actionResult.payload;
    if (documentData && documentData.content) {
      setShowPDF({
        isShow: true,
        productName:
          order?.productName +
          (orderItemStatus(row) === `Returned (#${row.productReturnId})`
            ? ` - RETURN`
            : ` - TISSUE TRACKING`),
        fileName:
          orderItemStatus(row) === `Returned (#${row.productReturnId})`
            ? `RETURN_${order?.orderNumber}`
            : `TISSUE_TRACKING_${order?.orderNumber}`,
      });
    }

    handleMenuClose(row.id.toString());
  };

  // Preview the optional document uploaded at reject time (returnRejectDocId).
  const handlePreviewRejectDocument = async (row: Row) => {
    if (!row.returnRejectDocId) return;
    const actionResult = await dispatch(fetchOrderDocumentById(row.returnRejectDocId));
    const documentData = actionResult.payload;
    if (documentData && documentData.content) {
      setShowPDF({
        isShow: true,
        productName: `${order?.productName || 'Product'} - Return Reject Document`,
        fileName: `RETURN_REJECT_${order?.orderNumber}`,
      });
    }
    handleMenuClose(row.id.toString());
  };

  // Preview the document uploaded at pending time (returnPendingDocId).
  const handlePreviewPendingDocument = async (row: Row) => {
    if (!row.returnPendingDocId) return;
    const actionResult = await dispatch(fetchOrderDocumentById(row.returnPendingDocId));
    const documentData = actionResult.payload;
    if (documentData && documentData.content) {
      setShowPDF({
        isShow: true,
        productName: `${order?.productName || 'Product'} - Return Label`,
        fileName: `RETURN_LABEL_${order?.orderNumber}`,
      });
    }
    handleMenuClose(row.id.toString());
  };

  const handleImageViewAction = async (row: Row) => {
    let documentIds =
      row.tissueTrackingInfo?.imagesOfWounds?.length > 0
        ? row.tissueTrackingInfo.imagesOfWounds
        : row.uploadedProductPackageIds?.length > 0
          ? row.uploadedProductPackageIds
          : [];
    const actionResult = await dispatch(fetchOrderDocumentsByIds(documentIds));
    const documentData = actionResult.payload;
    if (documentData && documentData.content) {
      setShowPDF({
        isShow: true,
        productName:
          row.uploadedProductPackageIds?.length > 0
            ? order?.productName + " - PRODUCT PACKAGING IMAGES"
            : order?.productName +
            (orderItemStatus(row) === `Returned (#${row.productReturnId})`
              ? ` - RETURN`
              : ` - Image of Wounds`),
        fileName:
          row.uploadedProductPackageIds?.length > 0
            ? `PRODUCT_PACKAGING_IMAGES_${order?.orderNumber}`
            : orderItemStatus(row) === `Returned (#${row.productReturnId})`
              ? `RETURN_${order?.orderNumber}`
              : `TISSUE_TRACKING_${order?.orderNumber}`,
      });
    }
    handleMenuClose(row.id.toString());
  };

  const handleViewMedicalNotesAction = async (row: Row) => {
    let documentIds = row.tissueTrackingInfo?.medicalNotes ?? [];
    const actionResult = await dispatch(fetchOrderDocumentsByIds(documentIds));
    const documentData = actionResult.payload;
    if (documentData && documentData.content) {
      setShowPDF({
        isShow: true,
        productName: order?.productName + " - Medical Notes",
        fileName: `TISSUE_TRACKING_MEDICAL_NOTES_${order?.orderNumber}`,
      });
    }
    handleMenuClose(row.id.toString());
  };

  /* istanbul ignore next -- never-used declaration (zero call sites) */
  const handleSerialNumberChange = (orderItemId: number, value: string) => {
    setSerialNumbers((prev) => ({ ...prev, [orderItemId]: value }));
  };

  // const checkSerialNumberPresent = (row: OrderItemDTO) => {
  //   const serialNumber = row.serialNumber;

  //   if (row?.tissueTrackingId || row?.productReturnId) {
  //     return true;
  //   } else {
  //     if (serialNumber === undefined || serialNumber === null || serialNumber.trim() === "") {
  //       return false;
  //     } else
  //       return true;
  //   }
  // };

  const dates = (row: OrderItemDTO) => {
    if (row.tissueTrackingId && row.appliedDate) {
      return dayjs(row.appliedDate).format("MM/DD/YYYY");
    } else if (row.productReturnId && row.returnedDate) {
      return dayjs(row.returnedDate).format("MM/DD/YYYY");
    } else {
      return "-";
    }
  };

  const orderItemRow: Row[] = useMemo(() => {
    let orderItems: Row[] = [];
    if (orderItemsListInfo) {
      orderItems = orderItemsListInfo
        .map((item: OrderItemDTO) => {
          return {
            select: <CustomCheckbox control={control} name="select" />,
            orderedGrafts: item.size,
            serialNumber: item.serialNumber,
            id: item.orderItemId,
            tissueTrackingId: item.tissueTrackingId,
            productReturnId: item.productReturnId,
            productReturnStatus: item.productReturnStatus,
            returnRequestComments: item?.returnTrackingInfo?.returnRequestComments,
            orderStatus: order?.orderStatus ?? location?.state?.orderDetails?.orderStatus,
            comment: getComment(item),
            tissueTrackingDocumentId: item.tissueTrackingDocumentId,
            tissueTrackingInfo: {
              barcodes: item.tissueTrackingInfo?.barcodes || [],
              imagesOfWounds: item.tissueTrackingInfo?.imagesOfWounds || [],
              medicalNotes: item.tissueTrackingInfo?.medicalNotes || [],
            },
            returnDocumentId: item.returnDocumentId,
            returnRejectDocId: (item.returnTrackingInfo as any)?.returnRejectDocId,
            returnPendingDocId: (item.returnTrackingInfo as any)?.returnPendingDocId,
            invoice: item.invoice,
            invoiceId: item.invoiceId,
            uploadedProductPackageIds:
              item.returnTrackingInfo?.productBoxPictures || [],
            appRetDate: dates(item) || "N/A",
            invoiceDate: item.invoicedDate
              ? dayjs(item.invoicedDate).format("MM/DD/YYYY")
              : "-",
            units: item.units,
            extendedPrice: item.extendedPrice,
            invoiceNumber: item.mfgInvoiceNumber,
            orderItemPrice: item.orderItemPrice, //CS-1560
            quantity: item.quantity,
            hasSKUPrice: item.hasSKUPrice,
            productItemDescription: item.productItemDescription,
            productItemId: item.productItemId
          };
        })
        .sort((a, b) => a.units - b.units);
    }
    return orderItems;
  }, [orderItemsListInfo, control, location?.state?.orderDetails?.orderStatus, order?.orderStatus]);

  // const orderItemStatus = (row: Row) => {
  //   if (row?.tissueTrackingId) {
  //     return `Applied (${row.invoice})`;
  //   } else if (row?.productReturnId) {
  //     return "Returned";
  //   }
  //   return row?.orderStatus === "DELIVERED" ? "Available" : "Pending";
  // };

  const orderItemStatus = useCallback((row: Row) => {
    if (row?.tissueTrackingId) {
      return `Applied (#${row.tissueTrackingId})`;
    } else if (row?.productReturnId) {
      // return `Returned (#${row.productReturnId})`;
      //CS-1164 START
      if (row.productReturnStatus === ORDER_AVAILABILITY.RETURN_INITIATED) {
        return `Return Initiated (#${row.productReturnId})`;
      } else if (row.productReturnStatus === ORDER_AVAILABILITY.RETURN_PENDING) {
        return `Return Pending (#${row.productReturnId})`;
      } else if (row.productReturnStatus === ORDER_AVAILABILITY.RETURNED) {
        return `Returned (#${row.productReturnId})`;
      } else if (row.productReturnStatus === ORDER_AVAILABILITY.RETURN_REJECTED) {
        // return `Available (Return Rejected)`;
        return `Available (Return Rejected)`;
      }
      //CS-1164 END
    } else if (row?.invoiceId) {
      return "Available";
    }
    // else if (row?.orderStatus === "DELIVERED") {
    //   return row?.invoiceId ? "Return Rejected (Invoiced)" : "Available";
    // }
    return "Pending";
  }, []);

  const detailsColumns = [
    { id: "orderedGrafts", label: "Ordered Size" },
    { id: "serialNumber", label: "Serial Number" },
    { id: "status", label: "Status" },
    { id: "appRetDate", label: "App/Ret Date" },
    { id: "invoiceDate", label: "Invoice" },
    { id: "action", label: "Action" },
    // { id: "images", label: "Images" },
    // { id: "comment", label: "Comment"}
  ];

  const [menuAnchor, setMenuAnchor] = useState<{
    [key: string]: null | HTMLElement;
  }>({});

  /* istanbul ignore next -- never-used declaration (zero call sites) */
  const handleMenuClick = (
    event: React.MouseEvent<HTMLElement>,
    rowId: string
  ) => {
    setMenuAnchor((prev) => ({ ...prev, [rowId]: event.currentTarget }));
  };

  const handleMenuClose = (rowId: string) => {
    setMenuAnchor((prev) => ({ ...prev, [rowId]: null }));
  };

  //CS-1164 START
  const showCustomCommentPopup = (row: any, field: string) => {
    let title = "";
    let body = "";

    if (field === "Return Comments") {
      if (row.productReturnStatus === ORDER_AVAILABILITY.RETURNED) {
        title = "Return Approval Comments";
      } else if (row.productReturnStatus === ORDER_AVAILABILITY.RETURN_REJECTED) {
        title = "Return Rejection Comments";
      } else {
        title = "Return Request Comments";
      }
      body = row.returnRequestComments || "";
    } else {
      title = row.tissueTrackingId
        ? "Comment Record product usage"
        : "Return Request Context";
      body = row.comment || "";
    }

    setCommentData({ title, body });
    setShowCommentPopup(true);
    handleMenuClose(row.id.toString());
  };

  const showProductReturnSummary = async (row: any) => {
    const response = await dispatch(fetchProductReturnAuditById(row.productReturnId))
    if (response?.payload) {
      setReturnAuditData(response.payload); // set audit data
    }
    // const body = response.payload.summary ;
    // const title = "Product Return Details";
    // const body = response.payload.data;
    // setCommentData({ title, body });
    setShowReturnPopup(true);
    handleMenuClose(row.id.toString());
  }
  //CS-1164 END

  const showCustomCommentPopupFromOrderForm = (row: any) => {
    const title = "Additional Notes / Comments";
    const body = row.additionalNotes;
    setCommentData({ title, body });
    setShowCommentPopup(true);
  };

  const hideCustomCommentPopup = () => {
    setShowCommentPopup(false);
  }

  // CS-991 Move PDF from action to Details Pages
  /* istanbul ignore next -- never-used declaration (zero call sites) */
  const renderPDFButton = () => (
    <Button
      color="success"
      onClick={() => order && handlePDFPreviewAction(order)}
      sx={{ whiteSpace: "nowrap" }}
      startIcon={<PictureAsPdfOutlined fontSize="small" />}
    >
      PDF
    </Button>
  );

  /* istanbul ignore next -- never-used declaration (zero call sites) */
  const renderPackingListButton = () => (
    <Button
      color="warning"
      sx={{ whiteSpace: "nowrap" }}
      onClick={() => order && handlePackagePreview(order)}
      startIcon={<PictureAsPdfOutlined fontSize="small" />}
    >
      Packing List
    </Button>
  );

  /* istanbul ignore next -- never-used declaration (zero call sites) */
  const renderSalesInvoiceButton = () => (
    <Button
      color="info"
      sx={{ whiteSpace: "nowrap" }}
      onClick={() => order && handleSalesInvoicePreviw(order)}
      startIcon={<PictureAsPdfOutlined fontSize="small" />}
    >
      Sales Invoice
    </Button>
  );

  /* istanbul ignore next -- never-used declaration (zero call sites) */
  const renderPrescriptionButton = () => (
    <Button
      color="success"
      sx={{ whiteSpace: "nowrap" }}
      onClick={() => order && handlePrescriptionPrview(order)}
      startIcon={<PictureAsPdfOutlined fontSize="small" />}
    >
      Prescription
    </Button>
  );

  /* istanbul ignore next -- never-used declaration (zero call sites) */
  const renderCMS1500FormButton = () => (
    <Button
      color="warning"
      sx={{ whiteSpace: "nowrap" }}
      onClick={() => order && handleCMSPrview(order)}
      startIcon={<PictureAsPdfOutlined fontSize="small" />}
    >
      CMS 1500 Form
    </Button>
  );

  /* istanbul ignore next -- never-used declaration (zero call sites) */
  const renderAssessmentFormButton = () => (
    <Button
      color="info"
      sx={{ whiteSpace: "nowrap" }}
      onClick={() => order && handleAssessmentForm(order)}
      startIcon={<PictureAsPdfOutlined fontSize="small" />}
    >
      Assessment Form
    </Button>
  );

  /* istanbul ignore next -- never-used declaration (zero call sites) */
  const renderProofOfDelivery = () => (
    <Button
      color="success"
      sx={{ whiteSpace: "nowrap" }}
      onClick={() => order && handleProofOfDeliveryPreviw(order)}
      startIcon={<PictureAsPdfOutlined fontSize="small" />}
    >
      Proof Of Delivery
    </Button>
  );

  const handlePDFPreviewAction = async (row: OrderInfo) => {
    const documentId = row.orderDocumentId ? row.orderDocumentId : 0;
    const actionResult = await dispatch(fetchOrderDocumentById(documentId));
    const documentData = actionResult.payload;

    if (documentData && documentData.content) {
      setShowPDF({
        isShow: true,
        productName: row.productName + ` - ORDER`,
        fileName: row.orderNumber,
      });
    }
  };

  const handlePackagePreview = async (row: OrderInfo) => {
    const orderId = row.orderId;
    const actionResult = await dispatch(previewPackagePDF(orderId));
    const documentData = actionResult.payload;
    if (documentData && documentData.content) {
      setShowPDF({
        isShow: true,
        productName: row.productName + ` - Packing List`,
        fileName: row.orderNumber + "_PackingList",
      });
    }
  };

  const handleSalesInvoicePreviw = async (row: OrderInfo) => {
    const orderId = row.orderId;
    const actionResult = await dispatch(previewSalesPDF(orderId));
    const documentData = actionResult.payload;
    if (documentData && documentData.content) {
      setShowPDF({
        isShow: true,
        productName: row.productName + ` - Sales Invoice`,
        fileName: row.orderNumber + "_SalesInvoice",
      });
    }
  };

  const handlePrescriptionPrview = async (row: OrderInfo) => {
    const orderId = row.orderId;
    const actionResult = await dispatch(previewPrescriptionPDF(orderId));
    const documentData = actionResult.payload;
    if (documentData && documentData.content) {
      setShowPDF({
        isShow: true,
        productName: row.productName + ` - Prescription`,
        fileName: row.orderNumber + "_Prescription",
      });
    }
  };

  const handleCMSPrview = async (row: OrderInfo) => {
    const orderId = row.orderId;
    const actionResult = await dispatch(previewCMSPDF(orderId));
    const documentData = actionResult.payload;
    if (documentData && documentData.content) {
      setShowPDF({
        isShow: true,
        productName: row.productName + ` - CMS 1500 Form`,
        fileName: row.orderNumber + "_CMS1500Form",
      });
    }
  };

  const handleProofOfDeliveryPreviw = async (row: OrderInfo) => {
    const orderId = row.orderId;
    const actionResult = await dispatch(previewProofOfDelivery(orderId));
    const documentData = actionResult.payload;
    if (documentData && documentData.content) {
      setShowPDF({
        isShow: true,
        productName: row.productName + ` - Proof Of Delivery`,
        fileName: row.orderNumber + "_ProofOfDelivery",
      });
    }
  };

  const handleAssessmentForm = async (row: OrderInfo) => {
    const orderId = row.orderId;
    const actionResult = await dispatch(previewEvaltionForm(orderId));
    const documentData = actionResult.payload;
    if (documentData && documentData.content) {
      setShowPDF({
        isShow: true,
        productName: row.productName + ` - Assessment Form`,
        fileName: row.orderNumber + "_AssessmentForm",
      });
    }
  };
  //

  //CS-1164 START
  const getActionColumnWidth = (count: number) => {
    if (count === 0) return 0;
    if (count === 1) return 1;
    if (count === 2) return 1.2;
    if (count === 3) return 1.5;
    if (count === 4) return 2;
    return 2.5; // For 5+ icons
  };


  const maxIconCount = Math.max(
    ...(orderItemRow?.map((row: any) => {
      return [
        row.tissueTrackingDocumentId || row.returnDocumentId,
        row.returnRequestComments,
        row.tissueTrackingInfo.imagesOfWounds?.length || row.uploadedProductPackageIds?.length,
        row.tissueTrackingId && row.tissueTrackingInfo.medicalNotes?.length,
        row.comment,
        row.productReturnId,
        row.returnPendingDocId,
        row.productReturnStatus === ORDER_AVAILABILITY.RETURN_REJECTED && row.returnRejectDocId
      ].filter(Boolean).length;
    }) || [0])
  );

  const actionColumnWidth = getActionColumnWidth(maxIconCount);
  const actionColPx = maxIconCount > 0 ? `${maxIconCount * 38 + 8}px` : "44px";
  const orderDetailsGridCols = canViewCOGSPrice
    ? `1fr 1.4fr 1.5fr 1.5fr 0.5fr 1fr ${actionColPx}`
    : `1fr 1.4fr 1.5fr 1.5fr 0.5fr ${actionColPx}`;
  //CS-1164 END

  useEffect(() => {
    if (!orderItemRow?.length) return;
    if (order?.productCategory !== PRODUCT_CATEGORY.CONSERVATIVE) return;
    const fetchKitItems = async () => {
      try {
        const productItemIds = orderItemRow.map(r => r.productItemId);
        const response = await dispatch(getProductItemkitItemByIds({productItemIds}));

        const data = response?.payload?.data;

        if (!data) return;

        const map: Record<number, any[]> = {};

        Object.entries(data).forEach(([id, items]: any) => {
          if (Array.isArray(items)) {
            map[Number(id)] = items.map(item => ({
              productName: `${item.productItemDescription} ${item.size}${item.productItemHcpcsCode
                  ? ` (${item.productItemHcpcsCode})`
                  : ""
                }`,
              graftQty: item.qty || 0,
              usageType: item.kitItemUsageType,
            }));
          }
        });

        setKitItemsMap(map);

      } catch (e) {
        console.error("Bulk kit item fetch failed", e);
      }
    };

    fetchKitItems();
  }, [dispatch, orderItemRow?.length, order?.orderId]);

  const detailsRows = orderItemRow?.map((row: any) => {
    const hasMenuItems =
      row.tissueTrackingDocumentId ||
      row.returnRequestComments ||
      row.returnDocumentId ||
      row.returnRejectDocId ||
      row.returnPendingDocId ||
      row.tissueTrackingInfo.imagesOfWounds?.length ||
      row.tissueTrackingInfo.medicalNotes?.length ||
      row.uploadedProductPackageIds?.length ||
      row.comment;

      const kitItems = kitItemsMap[row.productItemId] || [];

    return {
      ...row,
      kitItems: kitItems,
      status: orderItemStatus(row),
      action: hasMenuItems ? (
        <Box display="flex" alignItems="center" gap={0.5}>
          {row.tissueTrackingDocumentId || row.returnDocumentId ? (

            <CustomIconButton
              tooltipPlacement="top"
              color="info"
              size="small"
              variant="outlined"
              tooltipMessage="Document"
              onClick={() => handlePreviewAction(row)}
            >
              <AssignmentOutlined fontSize="small" />
            </CustomIconButton>

          ) : null}
          {row.productReturnStatus === ORDER_AVAILABILITY.RETURN_REJECTED && row.returnRejectDocId ? (
            <CustomIconButton
              tooltipPlacement="top"
              color="info"
              size="small"
              variant="outlined"
              tooltipMessage="Return Reject Document"
              onClick={() => handlePreviewRejectDocument(row)}
            >
              <DescriptionOutlined fontSize="small" />
            </CustomIconButton>
          ) : null}
          {row.returnPendingDocId ? (
            <CustomIconButton
              tooltipPlacement="top"
              color="info"
              size="small"
              variant="outlined"
              tooltipMessage="Return Label"
              onClick={() => handlePreviewPendingDocument(row)}
            >
              <DescriptionOutlined fontSize="small" />
            </CustomIconButton>
          ) : null}
          {row.returnRequestComments ? (
            <CustomIconButton
              tooltipPlacement="top"
              color="info"
              size="small"
              variant="outlined"
              tooltipMessage={row.productReturnStatus === ORDER_AVAILABILITY.RETURNED
                ? "Return Approval Comments"
                : row.productReturnStatus === ORDER_AVAILABILITY.RETURN_REJECTED
                  ? "Return Rejection Comments"
                  : "Return Request Comments"}
              onClick={() => showCustomCommentPopup(row, "Return Comments")}
            >
              <CommentOutlined fontSize="small" />
            </CustomIconButton>
          ) : null}

          {row.tissueTrackingInfo.imagesOfWounds?.length ||
            row.uploadedProductPackageIds?.length ? (
            <CustomIconButton
              tooltipPlacement="top"
              color="info"
              size="small"
              variant="outlined"
              tooltipMessage="Image"
              onClick={() => handleImageViewAction(row)}
            >
              <WallpaperOutlined fontSize="small" />
            </CustomIconButton>
          ) : null}

          {row.tissueTrackingId && row.tissueTrackingInfo.medicalNotes?.length ? (

            <CustomIconButton
              tooltipPlacement="top"
              color="info"
              size="small"
              variant="outlined"
              tooltipMessage="Medical Note"
              onClick={() => handleViewMedicalNotesAction(row)}
            >
              <NoteAddOutlined fontSize="small" />
            </CustomIconButton>
          ) : null}

          {row.comment ? (
            <CustomIconButton
              tooltipPlacement="top"
              color="info"
              size="small"
              variant="outlined"
              tooltipMessage={row.tissueTrackingId
                ? "Comment Record product usage"
                : "Return Request Context"}
              onClick={() => showCustomCommentPopup(row, "Return Request Context")}
            >
              <CommentOutlined fontSize="small" />
            </CustomIconButton>

          ) : null}
          {row.productReturnId ? (
            <CustomIconButton
              tooltipPlacement="top"
              color="info"
              size="small"
              variant="outlined"
              tooltipMessage="Return History"
              onClick={() => showProductReturnSummary(row)}
            >
              <InfoOutlined fontSize="small" />
            </CustomIconButton>
          ) : null}
        </Box>
      ) : null,
      invoiceDate: (
        <Box display="flex" flexDirection="column" alignItems="flex-start" gap={0.2} sx={{ width: '100%', minWidth: 0 }}>
          {row.invoiceNumber && canAccessApplication ? (
            <>
              <Link
                component="button"
                underline="hover"
                variant="body2"
                onClick={() => navigate("/invoice_list", { state: { orderNumber: order?.orderNumber } })}
                sx={{ color: "#42A5F5", fontWeight: 600, fontSize: "0.85rem", lineHeight: 1.4 }}
              >
                {row.invoiceNumber}
              </Link>
              {row.invoiceDate && (
                <Typography sx={{ fontSize: "0.75rem", color: mTokens.textSecondary, lineHeight: 1.3 }}>
                  {row.invoiceDate}
                </Typography>
              )}
            </>
          ) : (
            <Typography sx={{ fontSize: "0.85rem", color: mTokens.textPrimary }}>
              {row.invoiceNumber && row.invoiceDate ? `${row.invoiceNumber} ${row.invoiceDate}` : "-"}
            </Typography>
          )}
        </Box>
      ),
    };
  });


  const handleShipmentTracking = (order: OrderInfo) => {
    setShipmentInfoOpen(true);
    // const carrierUrls: { [key: string]: string } = {
    //   FEDEX: `https://fedex.com/fedextrack/?trknbr=${order.trackingNumber}`,
    //   USPS: `https://tools.usps.com/go/TrackConfirmAction?tLc=3&text28777=&tLabels=${order.trackingNumber}%2C%2C`,
    //   DHL: `https://www.dhl.com/us-en/home/tracking.html?tracking-id=${order.trackingNumber}&submit=1&inputsource=marketingstage`,
    //   UPS: `https://www.ups.com/track?tracknum=${order.trackingNumber}&loc=en_US&requester=QUIC/`,
    // };

    // if (order.trackingNumber && order.shippingCarrier in carrierUrls) {
    //   window.open(carrierUrls[order.shippingCarrier], "_blank");
    // } else {
    //   console.warn("Unsupported carrier or missing tracking number", order);
    // }
  };
  const totalAmount = detailsRows?.reduce((sum: any, row: any) => {
    return sum + Number(row?.quantity * row.extendedPrice);
  }, 0);
  const totalQuantity = useMemo(
    () => orderItemsListInfo?.reduce((sum, item: any) => sum + (item.quantity || 0), 0) ?? 0,
    [orderItemsListInfo]
  );
  const totalInvoiceCount = useMemo(() => {
    const ids = new Set(orderItemsListInfo?.filter((i: any) => i.invoiceId).map((i: any) => i.invoiceId) ?? []);
    return ids.size;
  }, [orderItemsListInfo]);
  const patientInitials = useMemo(() => {
    const name = order?.patientName || (order?.orderInfo as any)?.patient || '';
    return name.split(' ').map((n: string) => n[0] || '').join('').substring(0, 2).toUpperCase() || '?';
  }, [order]);
  //CS-1560 - Now order total is calculated from backend
  // const totalPrice = detailsRows
  //   .filter((row) => !(row.productReturnId && row.productReturnStatus === ORDER_AVAILABILITY.RETURNED))//CS-1164
  //   .reduce((sum, row) => {
  //     if (row.extendedPrice != null && row.units != null) {
  //       return sum + (row.hasSKUPrice ? row.extendedPrice : row.extendedPrice * row.units);
  //     }
  //     return sum;
  //   }, 0);

  /** CS-1845 — Price breakdown: compute discount & shipping for all orders.
   *  Discount percent and amount are stored in order_info JSON (discount / discountAmount). */
  const orderAmountsBreakdown = useMemo(() => {
    const src = OrderObject ?? order;
    if (!src?.orderItems?.length) return null;
    const oi = src.orderInfo as Record<string, string | undefined> | undefined;
    const shipRaw = oi?.shipping_charges ?? oi?.shippingPrice;
    const shipParsed = shipRaw != null && String(shipRaw).trim() !== "" ? Number(shipRaw) : 0;
    const safeShip = Number.isFinite(shipParsed) ? shipParsed : 0;

    const discRaw = oi?.discount;
    const discPct = discRaw != null && String(discRaw).trim() !== "" ? Number(discRaw) : NaN;
    const discountPercent =
      Number.isFinite(discPct) && discPct > 0 ? discPct : null;

    const discAmtRaw = oi?.discountAmount;
    const discAmt = discAmtRaw != null && String(discAmtRaw).trim() !== "" ? Number(discAmtRaw) : 0;
    const safeDiscAmt = Number.isFinite(discAmt) && discAmt > 0 ? discAmt : 0;

    const extendedSubtotal = src.orderItems.reduce((sum, it) => sum + Number(it.orderItemPrice ?? 0), 0);
    const orderTotal = Math.max(0, extendedSubtotal - safeDiscAmt) + safeShip;

    return {
      extendedSubtotal,
      discountAmount: safeDiscAmt,
      discountPercent: discountPercent,
      shippingCharges: safeShip,
      lateFees: 0,
      orderTotal,
      total: orderTotal,
    };
  }, [OrderObject, order]);

  const orderObj: OrderFulfillmentInfo = {
    orderId: order?.orderId || 0,
    practiceId: order?.practiceId || 0,
    ivrId: order?.ivrId || 0,
    patientId: order?.patientId || 0,
    practiceName: order?.practiceName || "",
    manufacturerName: order?.manufacturerName || "",
    poNumber: order?.poNumber || "",
    orderStatusToUpdate: order?.orderStatus || "",
    updateStatusDate: new Date().toISOString(),
    dateOfService: order?.dateOfService || '',
    patientName: order?.patientName || "",
    productName: order?.productName || "",
    providerName: order?.providerName || "",
    orderNumber: order?.orderNumber || "",
    orderDate: order?.orderDate || "",
    orderType: order?.orderType || "",
    orderStatus: order?.orderStatus || "",
    mfgConfirmationNumber: order?.mfgConfirmationNumber || "",
    shippedDate: order?.shippedDate || "",
    deliveredDate: order?.deliveredDate || "",
    processedDate: order?.processedDate || "",
    shippingCarrier: order?.shippingCarrier || "",
    trackingNumber: order?.trackingNumber || "",
    orderItems: orderItemsListInfo || [],
    manufacturerOrderId: order?.manufacturerOrderId || "",
    manufacturerPatientId: order?.manufacturerPatientId || "",
  };

  const handleEditClick = () => {
    setPoNumberValue(order?.poNumber || getValues("po") || "");
    setIsEditing(true);
  };

  const showExcelPopupData = (event: React.MouseEvent<HTMLElement>) => {
    setShowExcelPopup(true)
  };

  const renderPoNumberComponent = () => {
    return (
      <CustomTextField
        controllerName="po"
        autoFocus
        control={control}
        value={poNumberValue}
        onChange={(event) => {
          setPoNumberValue(event.target.value);
        }}
        onBlur={async () => {
          setIsEditing(false);
          const newValue = poNumberValue.trim();

          if ((newValue && newValue !== getValues("po")) || (newValue !== order?.poNumber)) {
            setValue("po", newValue);

            const updatePoNumber = {
              ...orderObj,
              poNumber: newValue,
            };

            try {
              const response = await dispatch(updateOrder({
                orderUpdataData: updatePoNumber,
                interceptorOption: { skipErrorPopup: true }
              }));

              if (response.payload && response.payload.code === "V3OK" && response.payload.message === "SUCCESS") {
                let successObj: SingleAlertInfo = {
                  message: "Po Number updated successfully",
                  alertType: "success"
                };
                dispatch(setSingleAlertObj(successObj));

                navigate(location.pathname, {
                  state: {
                    ...location.state,
                    orderDetails: {
                      ...order,
                      poNumber: newValue
                    }
                  },
                  replace: true
                });
              }
            } catch (error) {
              console.error("Error updating PO number:", error);
            }
          } else {
            const originalValue = getValues("po") || order?.poNumber || "";
            setPoNumberValue(originalValue);
          }
        }}
        name="po"
      />
    );
  };

  // CS-1251 
  const handleDocumentsMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setDocumentsMenuAnchor(event.currentTarget);
  };

  const handleDocumentsMenuClose = () => {
    setDocumentsMenuAnchor(null);
  };

  const renderDocumentsMenuButton = () => {
    const dropdownPaperSx = {
      mt: 0.6,
      minWidth: 210,
      borderRadius: "12px",
      border: `1px solid ${mTokens.border}`,
      backgroundColor: mTokens.menuBg,
      backgroundImage: "none",
      boxShadow: isDarkModal
        ? "0 14px 36px rgba(2,6,23,0.55)"
        : "0 14px 32px rgba(15,23,42,0.14)",
      overflow: "hidden",
    };

    const docItemSx = {
      display: "flex", alignItems: "center",
      borderRadius: "8px", mx: 0.75, my: 0.3, px: 1.1, py: 0.8, gap: 1.25,
      "&:hover": { backgroundColor: `${mTokens.accent}18` },
    };

    const docIconSx = {
      width: 28, height: 28, borderRadius: "7px",
      border: `1px solid ${mTokens.accent}44`,
      backgroundColor: `${mTokens.accent}14`,
      display: "flex", alignItems: "center", justifyContent: "center",
      flexShrink: 0, color: mTokens.accent,
      "& svg": { fontSize: "0.95rem" },
    };

    const actionItemSx = (color: string) => ({
      display: "flex", alignItems: "center",
      borderRadius: "8px", mx: 0.75, my: 0.3, px: 1.1, py: 0.8, gap: 1.25,
      "&:hover": { backgroundColor: `${color}18` },
    });

    const actionIconSx = (color: string) => ({
      width: 28, height: 28, borderRadius: "7px",
      border: `1px solid ${color}55`,
      backgroundColor: `${color}14`,
      display: "flex", alignItems: "center", justifyContent: "center",
      flexShrink: 0, color,
      "& svg": { fontSize: "0.95rem" },
    });

    const actionColors: Record<string, string> = {
      warning: "#F59E0B", error: "#EF4444", success: "#10B981", info: "#3B82F6", primary: mTokens.accent,
    };

    const visibleActions = actions.filter(a => !a.isHidden);
    const actionOpen = Boolean(actionMenuAnchor);

    return (
      <Box display="flex" alignItems="center" gap={1}>
        {/* Documents button */}
        <Box
          component="button"
          onClick={handleDocumentsMenuOpen}
          sx={{
            display: "flex", alignItems: "center", gap: 0.8,
            px: 1.6, height: 36,
            border: `1px solid ${mTokens.accent}`,
            borderRadius: "10px",
            backgroundColor: "transparent",
            color: mTokens.accent,
            cursor: "pointer",
            fontSize: "0.82rem", fontWeight: 700,
            letterSpacing: "0.04em",
            transition: "all 0.2s",
            "&:hover": { backgroundColor: `${mTokens.accent}14` },
            "& svg": { fontSize: "1rem" },
          }}
        >
          <PictureAsPdfOutlined />
          Documents
          <KeyboardArrowDown sx={{ fontSize: "1rem !important", ml: 0.2, transform: Boolean(documentsMenuAnchor) ? "rotate(180deg)" : "rotate(0deg)", transition: "transform 0.25s" }} />
        </Box>
        <Menu
          anchorEl={documentsMenuAnchor}
          open={Boolean(documentsMenuAnchor)}
          onClose={handleDocumentsMenuClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "right" }}
          MenuListProps={{ sx: { py: 0.7 } }}
          PaperProps={{ elevation: 0, sx: dropdownPaperSx }}
        >
          {order?.orderDocumentId != null && OrderObject && (
            <MenuItem sx={docItemSx} onClick={() => { handlePDFPreviewAction(OrderObject); handleDocumentsMenuClose(); }}>
              <Box sx={docIconSx}><AssignmentOutlined /></Box>
              <Typography sx={{ fontSize: "0.875rem", fontWeight: 500, color: mTokens.textPrimary }}>Order PDF</Typography>
            </MenuItem>
          )}
          {order?.productCategory === PRODUCT_CATEGORY.CONSERVATIVE && (
            <MenuItem sx={docItemSx} onClick={() => { handlePackagePreview(order); handleDocumentsMenuClose(); }}>
              <Box sx={docIconSx}><WallpaperOutlined /></Box>
              <Typography sx={{ fontSize: "0.875rem", fontWeight: 500, color: mTokens.textPrimary }}>Packing List</Typography>
            </MenuItem>
          )}
          {order?.productCategory === PRODUCT_CATEGORY.CONSERVATIVE && canAccessSalesInvoice && (
            <MenuItem sx={docItemSx} onClick={() => { handleSalesInvoicePreviw(order); handleDocumentsMenuClose(); }}>
              <Box sx={docIconSx}><ReceiptLongOutlined /></Box>
              <Typography sx={{ fontSize: "0.875rem", fontWeight: 500, color: mTokens.textPrimary }}>Sales Invoice</Typography>
            </MenuItem>
          )}
          {order?.productCategory === PRODUCT_CATEGORY.CONSERVATIVE && (
            <MenuItem sx={docItemSx} onClick={() => { handlePrescriptionPrview(order); handleDocumentsMenuClose(); }}>
              <Box sx={docIconSx}><NoteAddOutlined /></Box>
              <Typography sx={{ fontSize: "0.875rem", fontWeight: 500, color: mTokens.textPrimary }}>Prescription</Typography>
            </MenuItem>
          )}
          {order?.patientId != null && (
            <MenuItem sx={docItemSx} onClick={() => { handleCMSPrview(order); handleDocumentsMenuClose(); }}>
              <Box sx={docIconSx}><AssignmentReturnedOutlined /></Box>
              <Typography sx={{ fontSize: "0.875rem", fontWeight: 500, color: mTokens.textPrimary }}>CMS 1500 Form</Typography>
            </MenuItem>
          )}
          {order?.productCategory === PRODUCT_CATEGORY.CONSERVATIVE && (
            <MenuItem sx={docItemSx} onClick={() => { handleAssessmentForm(order); handleDocumentsMenuClose(); }}>
              <Box sx={docIconSx}><TroubleshootOutlined /></Box>
              <Typography sx={{ fontSize: "0.875rem", fontWeight: 500, color: mTokens.textPrimary }}>Assessment Form</Typography>
            </MenuItem>
          )}
          {order?.productCategory === PRODUCT_CATEGORY.CONSERVATIVE && order.orderStatus === "DELIVERED" && (
            <MenuItem sx={docItemSx} onClick={() => { handleProofOfDeliveryPreviw(order); handleDocumentsMenuClose(); }}>
              <Box sx={docIconSx}><LocalShippingOutlined /></Box>
              <Typography sx={{ fontSize: "0.875rem", fontWeight: 500, color: mTokens.textPrimary }}>Proof Of Delivery</Typography>
            </MenuItem>
          )}
        </Menu>

        {/* Excel data button */}
        {SalesDetailsInfo?.[0]?.invoiceNum && order?.orderId === Number(SalesDetailsInfo[0].orderId) && canViewExcelData && (
          <Box
            component="button"
            onClick={showExcelPopupData}
            sx={{
              display: "flex", alignItems: "center", gap: 0.8,
              px: 1.6, height: 36,
              border: `1px solid ${mTokens.border}`,
              borderRadius: "10px",
              backgroundColor: mTokens.bg,
              color: mTokens.textSecondary,
              cursor: "pointer",
              fontSize: "0.82rem", fontWeight: 600,
              transition: "all 0.2s",
              "&:hover": { borderColor: "#16A34A", color: "#16A34A", backgroundColor: "rgba(22,163,74,0.06)" },
            }}
          >
            <img src={require("../../../assets/excel_icon.png")} alt="Excel" style={{ width: 18, height: 18 }} />
            View Excel Data
          </Box>
        )}

        {/* Action button */}
        <Box
          component="button"
          onClick={(e: React.MouseEvent<HTMLElement>) => setActionMenuAnchor(e.currentTarget)}
          disabled={!hasVisibleActions}
          sx={{
            display: "flex", alignItems: "center", gap: 0.8,
            px: 1.6, height: 36,
            border: `1px solid ${mTokens.accent}`,
            borderRadius: "10px",
            backgroundColor: "transparent",
            color: mTokens.accent,
            cursor: hasVisibleActions ? "pointer" : "not-allowed",
            opacity: hasVisibleActions ? 1 : 0.5,
            fontSize: "0.82rem", fontWeight: 700,
            letterSpacing: "0.04em",
            transition: "all 0.2s",
            "&:hover": hasVisibleActions ? { backgroundColor: `${mTokens.accent}14` } : {},
            "& svg": { fontSize: "1rem" },
          }}
        >
          <BoltOutlined />
          Action 
          <KeyboardArrowDown sx={{ fontSize: "1rem !important", ml: 0.2, transform: actionOpen ? "rotate(180deg)" : "rotate(0deg)", transition: "transform 0.25s" }} />
        </Box>
        <Menu
          anchorEl={actionMenuAnchor}
          open={actionOpen}
          onClose={() => setActionMenuAnchor(null)}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "right" }}
          MenuListProps={{ sx: { py: 0.7 } }}
          PaperProps={{ elevation: 0, sx: dropdownPaperSx }}
        >
          {visibleActions.map((action, i) => {
            const col = actionColors[action.color || "primary"] || mTokens.accent;
            return (
              <MenuItem
                key={`${action.label}-${i}`}
                disabled={action.disabled}
                onClick={() => { setActionMenuAnchor(null); action.onClick && action.onClick(); }}
                sx={actionItemSx(col)}
              >
                {action.icon && <Box sx={actionIconSx(col)}>{action.icon}</Box>}
                <Typography sx={{ fontSize: "0.875rem", fontWeight: 500, color: mTokens.textPrimary, flex: 1 }}>
                  {action.label}
                </Typography>
              </MenuItem>
            );
          })}
        </Menu>
      </Box>
    );
  };
  //
  //CS-1302 - Start
  const handleSignatureData = async (data: any) => {
    const payload = {
      orderId: order?.orderId || OrderObject?.orderId || location?.state?.orderDetails?.orderId,
      providerName: data?.providerInformation?.name,
      signature: data?.providerInformation?.signature,
      productId: orderItemsListInfo ? orderItemsListInfo[0]?.productId : 0,
    }
    await dispatch(saveProviderSignAgainstOrder(payload)).then((response) => {
      if (response.payload && response.payload?.code === SUCCESS_CODE) {
        dispatch(
          setSingleAlertObj({
            alertType: "success",
            // message: `Order (${location?.state?.orderDetails?.orderNumber}) signed successfully!`,
            message: `Order (${order?.orderNumber || OrderObject?.orderNumber || location?.state?.orderDetails?.orderNumber}) signed and placed successfully.`,//Success Message Changed
          })
        )
        navigate("/order_list")
      }
    }).catch((error) => {
      dispatch(
        setSingleAlertObj({
          alertType: "error",
          message: "Something went wrong while signing the order!",
          // showButton: true,
          // buttonText: "OK",
          // onButtonClick: () => { },
        })
      )
    });
  };
  //CS-1302 - End

  //CS-1560 - Update Order Item Price in details page
  const handleUpdateOrderItemPrice = async (data: OrderItemsPriceUpdateRequest) => {
    if (data?.orderId && data?.orderItems && data?.orderItems.length > 0) {
      await dispatch(updateOrderItemsPrice(data)).then(async (res) => {
        if (res.payload && res.payload?.code === SUCCESS_CODE) {
          let successObj: SingleAlertInfo = {
            message: "Order item price updated successfully",
            alertType: "success"
          };
          await dispatch(setSingleAlertObj(successObj));
          await Promise.all([
            dispatch(getOrderItemsByOrderId(data.orderId)),
            dispatch(fetchOrderById({ orderId: data.orderId, isSaveAuditLog: true })),
          ]);
        }
      }).catch(() => {
        let errorObj: SingleAlertInfo = {
          message: "Failed to update order item price",
          alertType: "error"
        };
        dispatch(setSingleAlertObj(errorObj));
      })
    }
  }

  /* ── local helpers — match popup (useModalStyles) design system ── */
  const sectionCardSx = {
    borderRadius: "16px",
    border: `1px solid ${mTokens.border}`,
    backgroundColor: mTokens.bg,
    backgroundImage: "none",
    boxShadow: isDarkModal
      ? "0 10px 20px rgba(0,0,0,0.1)"
      : "none",
    overflow: "hidden",
  };


  const InfoRow = ({ label, value }: { label: string; value?: any }) => (
    <Box display="flex" alignItems="center" py={0.8} sx={{ borderBottom: `1px solid ${mTokens.border}`, "&:last-child": { borderBottom: "none" } }}>
      <Typography sx={{ fontSize: "0.82rem", color: mTokens.textSecondary, width: "45%", flexShrink: 0, pt: 0.15 }}>
        {label}
      </Typography>
      <Typography sx={{ fontSize: "0.88rem", color: mTokens.textPrimary, fontWeight: 600, flex: 1 }} component="div">
        {value ?? "—"}
      </Typography>
    </Box>
  );

  const colHeaderSx = { fontSize: "0.68rem", fontWeight: 700, color: mTokens.textSecondary, textTransform: "uppercase" as const, letterSpacing: "0.08em" };
  const colBodySx = { fontSize: "0.88rem", color: mTokens.textPrimary, fontWeight: 500 };
  const deliveryLabelSx = { fontSize: "0.65rem", color: mTokens.textSecondary, mb: 0.2, textTransform: "uppercase" as const, letterSpacing: "0.07em", fontWeight: 600 };
  const deliveryValueSx = { fontSize: "0.88rem", color: mTokens.textPrimary, fontWeight: 600 };

  const getStatusChipSx = (status: string) => {
    if (status?.includes("Applied")) return { backgroundColor: "rgba(20,184,166,0.15)", color: "#14b8a6", border: "1px solid rgba(20,184,166,0.4)", fontWeight: 700 };
    if (status === "Available") return { backgroundColor: "rgba(40,167,69,0.15)", color: "#28a745", border: "1px solid rgba(40,167,69,0.4)", fontWeight: 700 };
    if (status?.includes("Return Initiated")) return { backgroundColor: "rgba(0,184,217,0.15)", color: "#00B8D9", border: "1px solid rgba(0,184,217,0.4)", fontWeight: 700 };
    if (status?.includes("Return Pending")) return { backgroundColor: "rgba(255,171,0,0.15)", color: "#FFAB00", border: "1px solid rgba(255,171,0,0.4)", fontWeight: 700 };
    if (status?.includes("Return")) return { backgroundColor: "rgba(220,53,69,0.15)", color: "#dc3545", border: "1px solid rgba(220,53,69,0.4)", fontWeight: 700 };
    return { backgroundColor: "rgba(253,126,20,0.15)", color: "#fd7e14", border: "1px solid rgba(253,126,20,0.4)", fontWeight: 700 };
  };

  const getDeliveryStatusColor = (status: string | undefined) => {
    switch (status) {
      case "DELIVERED": return "#28a745";
      case "SHIPPED": return "#5dabff";
      case "CANCELED": return "#dc3545";
      case "PROCESSING": return "#fd7e14";
      default: return mTokens.textPrimary;
    }
  };

  const summaryStats = [
    { label: "Total Items", value: String(orderItemsListInfo?.length ?? 0), color: "#7C3AED", bg: "rgba(124,58,237,0.1)", icon: <AssignmentOutlined /> },
    { label: "Total Invoices", value: String(totalInvoiceCount), color: "#2563EB", bg: "rgba(37,99,235,0.1)", icon: <ReceiptLongOutlined /> },
    { label: "Total Quantity", value: String(totalQuantity), color: "#16A34A", bg: "rgba(22,163,74,0.1)", icon: <TrendingUpOutlined /> },
    ...(canViewCOGSPrice
      ? [{ label: "Total Amount", value: priceFormatter(Number(orderAmountsBreakdown?.total ?? OrderObject?.orderTotalPrice ?? order?.orderTotalPrice ?? 0)), color: "#D97706", bg: "rgba(217,119,6,0.1)", icon: <SyncOutlined /> }]
      : []),
  ];

  const orderStatusLabel = order?.orderStatus || "";
  const isOrderActiveStatus = !hideAllActionsForInactiveOrder && order?.orderStatus !== ORDER_STATUS.CANCELED;
  const statusChipColor = order?.orderStatus === ORDER_STATUS.CANCELED ? "#dc3545"
    : order?.orderStatus === ORDER_STATUS.DELIVERED ? "#28a745"
    : order?.orderStatus === ORDER_STATUS.SHIPPED ? "#5dabff"
    : "#14b8a6";



  return (
    <Box sx={{
      mx: embedded ? 0 : { xs: "10px", sm: "20px" },
      my: embedded ? 0 : "12px",
      height: { md: embedded ? "auto" : "calc(100vh - 116px)" },
      display: "flex",
      flexDirection: "column",
      overflow: { xs: "visible", md: embedded ? "visible" : "hidden" },
    }}>
      {showPDF && (
        <PDFViewer
          isOpen={showPDF.isShow}
          onClose={() => {
            setShowPDF({ isShow: false, productName: "", fileName: "" });
            dispatch(resetOrderDocumentInfo());
          }}
          title={showPDF.productName}
          fileName={showPDF.fileName}
          base64String={orderDocumentInfo?.content || ""}
        />
      )}
      {showSignatureSubmitPopup && (
        <SigantureSubmitPopup
          open={showSignatureSubmitPopup}
          onClose={() => { setShowSignatureSubmitPopup(false); }}
          addProductItem={() => { }}
          productItemDetails={{}}
          isEdit={false}
          practiceName={order?.practiceName || location?.state?.orderDetails?.practiceName}
          selectedProviderData={[{ providerName: order?.orderInfo?.provider || order?.provider || location?.state?.orderDetails?.orderInfo?.provider, npi: "", ptan: "", taxId: "" }]}
          addSignature={handleSignatureData}
          authorizedSigner={false}
        />
      )}

      {/* Page Header */}
      <Box mb={1.5} display="flex" alignItems="flex-start" justifyContent="space-between" flexWrap="wrap" gap={1} sx={{ flexShrink: 0 }}>
        {!embedded ? (
          <Box display="flex" alignItems="flex-start" gap={1.5}>
            {/* Back icon button */}
            <PageBackButton
              onClick={() => location.state?.fromStripeOrderPayment ? navigate("/order_list") : navigate(-1)}
            />
            <Box>
              <Typography sx={{ fontSize: "0.7rem", fontWeight: 700, color: mTokens.textSecondary, textTransform: "uppercase", letterSpacing: "0.12em", mb: 0.3 }}>
                Orders
              </Typography>
              <Box display="flex" alignItems="center" gap={1.5}>
                <Typography sx={{ fontSize: "1.6rem", fontWeight: 800, color: mTokens.textPrimary, lineHeight: 1.1 }}>
                  {order?.orderNumber || "—"}
                  {order?.isUpfrontOrder && (
                    <BoltOutlined sx={{ fontSize: 22, color: "#00E5B0", ml: 0.5, verticalAlign: "middle" }} titleAccess="Upfront Order" />
                  )}
                </Typography>
                <Chip
                  label={orderStatusLabel || "Active"}
                  size="small"
                  sx={{
                    backgroundColor: `${statusChipColor}1a`,
                    color: statusChipColor,
                    border: `1px solid ${statusChipColor}55`,
                    fontWeight: 700,
                    fontSize: "0.72rem",
                    height: 24,
                  }}
                />
              </Box>
            </Box>
          </Box>
        ) : (
          <Box display="flex" alignItems="center" gap={1.5} flexWrap="wrap">
            <Typography
              sx={{
                fontSize: "1.35rem",
                fontWeight: 800,
                color: mTokens.textPrimary,
                lineHeight: 1.2,
              }}
            >
              Order Detail
              {order?.orderNumber ? (
                <Typography
                  component="span"
                  sx={{ ml: 1, fontSize: "1.05rem", fontWeight: 700, color: "#38bdf8" }}
                >
                  #{order.orderNumber}
                </Typography>
              ) : null}
              {order?.isUpfrontOrder && (
                <BoltOutlined
                  sx={{ fontSize: 20, color: "#00E5B0", ml: 0.5, verticalAlign: "middle" }}
                  titleAccess="Upfront Order"
                />
              )}
            </Typography>
            <Chip
              label={orderStatusLabel || "Active"}
              size="small"
              sx={{
                backgroundColor: `${statusChipColor}1a`,
                color: statusChipColor,
                border: `1px solid ${statusChipColor}55`,
                fontWeight: 700,
                fontSize: "0.72rem",
                height: 24,
              }}
            />
          </Box>
        )}
        <Box display="flex" alignItems="center" gap={1} flexWrap="wrap">
          {renderDocumentsMenuButton()}
          <Button
            color="warning"
            variant="outlined"
            startIcon={<Create />}
            style={{
              display: `${hideElement((
                !canSignOrder || (order?.orderStatus ?? location?.state?.orderDetails?.orderStatus) !== ORDER_STATUS.PENDING || (order?.canSignOrder ?? location?.state?.orderDetails?.canSignOrder) !== true || (order?.customConfig?.provider_signature_required ?? location?.state?.orderDetails?.customConfig?.provider_signature_required) !== "Y"))}`
            }}
            onClick={() => setShowSignatureSubmitPopup(true)}
          >
            SIGN ORDER
          </Button>
        </Box>
      </Box>

      {/* Main content */}
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5, overflow: { xs: "visible", md: "hidden" }, flex: { md: 1 }, minHeight: { md: 0 } }}>
        <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "2fr 1fr" }, gridTemplateRows: { md: "1fr" }, gap: 1.5, flex: { md: 1 }, minHeight: { md: 0 }, overflow: { xs: "visible", md: "hidden" } }}>

          {/* Left column */}
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5, overflow: { xs: "visible", md: "hidden" }, height: { md: "calc(100vh - 100px)" } }}>
            <Box sx={{ ...sectionCardSx, flexShrink: 0, display: "grid", gridTemplateColumns: { xs: "1fr 1fr", md: summaryStats.length === 4 ? "1fr 1fr 1fr 1fr" : "1fr 1fr 1fr" }, overflow: "hidden" }}>
              {summaryStats.map((stat, i) => (
                <Box key={stat.label} sx={{
                  display: "flex", alignItems: "center", gap: 1, px: 1.8, py: 1,
                  borderRight: { xs: i % 2 === 0 ? `1px solid ${mTokens.border}` : "none", md: i < summaryStats.length - 1 ? `1px solid ${mTokens.border}` : "none" },
                  borderBottom: { xs: i < 2 ? `1px solid ${mTokens.border}` : "none", md: "none" },
                }}>
                  <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", width: 32, height: 32, borderRadius: "8px", backgroundColor: stat.bg, flexShrink: 0, "& svg": { fontSize: "1rem", color: stat.color } }}>
                    {stat.icon}
                  </Box>
                  <Box>
                    <Typography sx={{ fontSize: "0.62rem", color: mTokens.textSecondary, fontWeight: 600, textTransform: "uppercase" as const, letterSpacing: "0.07em", mb: 0.2 }}>{stat.label}</Typography>
                    <Typography sx={{ fontSize: "1.05rem", fontWeight: 800, color: mTokens.textPrimary, lineHeight: 1.2 }}>{stat.value}</Typography>
                  </Box>
                </Box>
              ))}
            </Box>

            {/* Order Details card */}
            <Box sx={{ ...sectionCardSx, display: "flex", flexDirection: "column", overflow: "hidden", flexShrink: 0 }}>
              <SectionHeader
                icon={<AssignmentOutlined fontSize="small" />}
                title="Order Details"
                action={
                  <Box
                    component="button"
                    style={{ display: `${hideElement(!canUpdateOrderItemPrice || isManualProduct)}` }}
                    onClick={() => setShowEditAmountPopup(true)}
                    sx={{
                      display: "flex", alignItems: "center", gap: 0.8,
                      px: 1.4, height: 32,
                      border: `1px solid ${mTokens.accent}`,
                      borderRadius: "10px",
                      backgroundColor: "transparent",
                      color: mTokens.accent,
                      cursor: "pointer",
                      fontSize: "0.78rem", fontWeight: 700,
                      letterSpacing: "0.04em",
                      transition: "all 0.2s",
                      "&:hover": { backgroundColor: `${mTokens.accent}14` },
                      "& svg": { fontSize: "0.95rem" },
                    }}
                  >
                    <ModeOutlined sx={{ fontSize: "0.95rem" }} />
                    Edit Order Amount
                  </Box>
                }
              />
              <Box sx={{ overflowY: { xs: "visible", md: "auto" }, maxHeight: { xs: "none", md: "max(0px, calc(100vh - 480px))" } }}>
                {(() => {
                  const notes = String((OrderObject?.orderInfo as any)?.notes ?? (order?.orderInfo as any)?.notes ?? "").trim() || null;
                  const NotesBlock = notes ? (
                    <Box sx={{ px: 2.8, py: 1.5, borderTop: `1px solid ${mTokens.border}` }}>
                      <Typography sx={{ fontSize: "0.72rem", color: mTokens.textSecondary, fontWeight: 700, textTransform: "uppercase" as const, letterSpacing: "0.08em", mb: 0.5 }}>Notes</Typography>
                      <Typography sx={{ fontSize: "0.875rem", color: mTokens.textPrimary, whiteSpace: "pre-wrap", lineHeight: 1.6 }}>{notes}</Typography>
                    </Box>
                  ) : null;

                  const isConservative = order?.productCategory === PRODUCT_CATEGORY.CONSERVATIVE;

                  const Header = isConservative ? (
                    <Box sx={{ display: "grid", gridTemplateColumns: "1fr auto", px: 2.8, py: 0.8, borderBottom: `1px solid ${mTokens.border}`, flexShrink: 0, backgroundColor: mTokens.headerFooterBg }}>
                      <Typography sx={colHeaderSx}>Description</Typography>
                      <Typography sx={{ ...colHeaderSx, textAlign: "center", minWidth: 48 }}>QTY</Typography>
                    </Box>
                  ) : (
                    /* Desktop-only header — hidden on mobile (mobile rows are self-labelled) */
                    <Box sx={{ display: { xs: "none", md: "grid" }, gridTemplateColumns: orderDetailsGridCols, gap: 1, px: 2.8, py: 0.8, borderBottom: `1px solid ${mTokens.border}`, flexShrink: 0, backgroundColor: mTokens.headerFooterBg }}>
                      <Typography sx={colHeaderSx}>Size</Typography>
                      <Typography sx={colHeaderSx}>Serial Number</Typography>
                      <Typography sx={colHeaderSx}>Status / Date</Typography>
                      <Typography sx={colHeaderSx}>Invoice</Typography>
                      <Typography sx={{ ...colHeaderSx, textAlign: "center" }}>QTY</Typography>
                      {canViewCOGSPrice && <Typography sx={{ ...colHeaderSx, textAlign: "right" }}>Amount</Typography>}
                      <Typography sx={colHeaderSx}></Typography>
                    </Box>
                  );

                  const Rows = isConservative ? (
                    <>
                      {detailsRows.map((row, index) => (
                        <Box key={index}>
                          <Box sx={{ display: "grid", gridTemplateColumns: "1fr auto", px: 2.8, py: 1, borderBottom: index < detailsRows.length - 1 ? `1px dashed ${mTokens.border}` : "none" }}>
                            <Box>
                              <Typography sx={{ fontSize: "0.875rem", color: mTokens.textPrimary, fontWeight: 500 }}>{row?.productItemDescription}</Typography>
                              {row.kitItems && row.kitItems.length > 0 && (
                                <Box sx={{ mt: 0.5, pl: 1 }}>
                                  {row.kitItems.map((item: any, idx: number) => (
                                    <Typography key={idx} sx={{ fontSize: "0.78rem", color: mTokens.textSecondary, mb: 0.3 }}>
                                      • {item.productName} – Qty: {item.graftQty}
                                    </Typography>
                                  ))}
                                </Box>
                              )}
                            </Box>
                            <Typography sx={{ fontSize: "0.875rem", color: mTokens.textPrimary, fontWeight: 500, textAlign: "center", minWidth: 48 }}>
                              {row.quantity ?? "—"}
                            </Typography>
                          </Box>
                        </Box>
                      ))}
                    </>
                  ) : (
                    <>
                      {detailsRows.map((row, index) => {
                        const rowBorder = index < detailsRows.length - 1 ? `1px dashed ${mTokens.border}` : "none";
                        const amountSx = {
                          fontSize: "0.875rem", color: mTokens.textPrimary, fontWeight: 600,
                          textDecoration: row.productReturnId && row.productReturnStatus === ORDER_AVAILABILITY.RETURNED ? "line-through red" : "none",
                          textDecorationThickness: row.productReturnId ? "2px" : "initial",
                        };
                        return (
                          <Box key={index}>
                            {/* ── Mobile card layout ── */}
                            <Box sx={{ display: { xs: "block", md: "none" }, px: 2, py: 1.2, borderBottom: rowBorder }}>
                              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", mb: 0.5 }}>
                                <Typography sx={{ fontSize: "0.9rem", fontWeight: 700, color: mTokens.textPrimary }}>{row.orderedGrafts}</Typography>
                                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 0.3 }}>
                                  <Chip label={row.status} title={row.status} size="small" sx={{ ...getStatusChipSx(row.status), fontSize: "0.7rem", height: 22 }} />
                                  {row.appRetDate && row.appRetDate !== "-" && (
                                    <Typography sx={{ fontSize: "0.7rem", color: mTokens.textSecondary }}>{row.appRetDate}</Typography>
                                  )}
                                </Box>
                              </Box>
                              {row.serialNumber && (
                                <Typography sx={{ fontSize: "0.78rem", color: mTokens.textSecondary, mb: 0.6 }}>SN: {row.serialNumber}</Typography>
                              )}
                              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", mb: 0.5 }}>
                                <Box sx={{ flex: 1, minWidth: 0, mr: 1 }}>{row.invoiceDate}</Box>
                                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 0.2, flexShrink: 0 }}>
                                  <Typography sx={{ fontSize: "0.78rem", color: mTokens.textSecondary }}>Qty: <Box component="span" sx={{ fontWeight: 700, color: mTokens.textPrimary }}>{row.quantity ?? "—"}</Box></Typography>
                                  {canViewCOGSPrice && row.extendedPrice != null && row.units != null && (
                                    <Typography sx={amountSx}>{priceFormatter(row?.orderItemPrice)}</Typography>
                                  )}
                                </Box>
                              </Box>
                              <Box sx={{ display: "flex", justifyContent: "flex-end" }}>{row.action}</Box>
                            </Box>

                            {/* ── Desktop grid layout ── */}
                            <Box sx={{ display: { xs: "none", md: "grid" }, gridTemplateColumns: orderDetailsGridCols, gap: 1, px: 2.8, py: 1, borderBottom: rowBorder, alignItems: "flex-start" }}>
                              <Typography sx={{ fontSize: "0.875rem", color: mTokens.textPrimary, fontWeight: 500, pt: 0.3 }}>{row.orderedGrafts}</Typography>
                              <Typography sx={{ fontSize: "0.875rem", color: mTokens.textPrimary, fontWeight: 500, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", pt: 0.3 }}>{row.serialNumber}</Typography>
                              <Box sx={{ display: "flex", flexDirection: "column", gap: 0.4 }}>
                                <Chip label={row.status} title={row.status} size="small" sx={{ ...getStatusChipSx(row.status), fontSize: "0.7rem", height: 22, alignSelf: "flex-start" }} />
                                {row.appRetDate && row.appRetDate !== "-" && (
                                  <Typography sx={{ fontSize: "0.75rem", color: mTokens.textSecondary }}>{row.appRetDate}</Typography>
                                )}
                              </Box>
                              {row.invoiceDate}
                              <Typography sx={{ fontSize: "0.875rem", color: mTokens.textPrimary, fontWeight: 500, textAlign: "center" }}>{row.quantity ?? "—"}</Typography>
                              {canViewCOGSPrice && row.extendedPrice != null && row.units != null && (
                                <Typography sx={{ ...amountSx, textAlign: "right" }}>{priceFormatter(row?.orderItemPrice)}</Typography>
                              )}
                              <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>{row.action}</Box>
                            </Box>
                          </Box>
                        );
                      })}
                    </>
                  );

                  return <>{Header}{Rows}{NotesBlock}</>;
                })()}
              </Box>
            </Box>

            {/* Delivery Information card */}
            <Box sx={{ ...sectionCardSx, flexShrink: 0 }}>
              <SectionHeader icon={<LocalShippingOutlined fontSize="small" />} title="Delivery Information" />
              <Box sx={{ px: 2.8, py: 1 }}>
                <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr 1fr", md: "2fr 1fr 1fr 1fr" }, gap: 1.2, mb: 0.5 }}>
                  <Box>
                    <Typography sx={deliveryLabelSx}>Carrier</Typography>
                    <Typography sx={deliveryValueSx}>{order?.shippingCarrier || "—"}</Typography>
                  </Box>
                  <Box>
                    <Typography sx={deliveryLabelSx}>Status</Typography>
                    <Typography sx={{ ...deliveryValueSx, color: getDeliveryStatusColor(order?.orderStatus), fontWeight: 700 }}>{order?.orderStatus || "—"}</Typography>
                  </Box>
                  <Box>
                    <Typography sx={deliveryLabelSx}>Tracking #</Typography>
                    {order?.trackingNumber ? (
                      <Link component="button" underline="hover" onClick={() => handleShipmentTracking(order)} sx={{ color: "#42A5F5", fontWeight: 600, fontSize: "0.88rem" }}>
                        {order.trackingNumber}
                      </Link>
                    ) : <Typography sx={deliveryValueSx}>—</Typography>}
                  </Box>
                  <Box>
                    <Typography sx={deliveryLabelSx}>Requested Delivery Date</Typography>
                    <Typography sx={deliveryValueSx}>{order?.requestedDeliveryDate || "—"}</Typography>
                  </Box>
                  <Box>
                    <Typography sx={deliveryLabelSx}>Shipping Method</Typography>
                    <Typography sx={deliveryValueSx}>{order?.orderStatus === ORDER_STATUS.PLACED ? order?.requestedShippingMethod || "—" : order?.actualShippingMethod || "—"}</Typography>
                  </Box>
                  <Box>
                    <Typography sx={deliveryLabelSx}>PO (if applicable)</Typography>
                    <Typography sx={deliveryValueSx}>{order?.poNumber || getValues("po") || "—"}</Typography>
                  </Box>
                  {(isNotPlacedOrCanceled || isShipped || isDelivered) && order?.shippedDate && (
                    <Box>
                      <Typography sx={deliveryLabelSx}>Shipped Date</Typography>
                      <Typography sx={deliveryValueSx}>{order.shippedDate}</Typography>
                    </Box>
                  )}
                  {(isNotPlacedOrCanceled || isDelivered) && order?.deliveredDate && (
                    <Box>
                      <Typography sx={deliveryLabelSx}>Date of Delivery</Typography>
                      <Typography sx={deliveryValueSx}>{order.deliveredDate}</Typography>
                    </Box>
                  )}
                  {(isNotPlacedOrCanceled || isProcessing || isShipped || isDelivered) && order?.orderInfo?.processedDate && (
                    <Box>
                      <Typography sx={deliveryLabelSx}>Processed Date</Typography>
                      <Typography sx={deliveryValueSx}>{order.orderInfo.processedDate}</Typography>
                    </Box>
                  )}
                </Box>
                {order?.orderStatus === ORDER_STATUS.PLACED && (
                  <Alert severity="info" sx={{ fontSize: "0.8rem", mt: 0.5 }}>
                    Delivery details will be available once the order is processed.
                  </Alert>
                )}
              </Box>
            </Box>
          </Box>{/* end left column */}

          {/* Right column */}
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5, overflow: { xs: "visible", md: "hidden" }, height: { md: "calc(100vh - 100px)" } }}>

            {/* Order Information card */}
            <Box sx={{ ...sectionCardSx, display: "flex", flexDirection: "column", flexShrink: 0 }}>
              <SectionHeader icon={<PersonOutlined fontSize="small" />} title="Order Information" />
              <Box sx={{ px: 2.8, py: 1, overflowY: { xs: "visible", md: "auto" }, maxHeight: { xs: "none", md: "max(0px, calc(100vh - 390px))" } }}>
                <Box display="flex" alignItems="center" py={1.5} sx={{ borderBottom: `1px solid ${mTokens.border}` }}>
                  <Typography sx={{ fontSize: "0.82rem", color: mTokens.textSecondary, width: "45%", flexShrink: 0 }}>Patient</Typography>
                  <Box display="flex" alignItems="center" gap={1}>
                    <Box sx={{ width: 28, height: 28, borderRadius: "50%", backgroundColor: `${mTokens.accent}22`, border: `1px solid ${mTokens.accent}55`, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                      <Typography sx={{ fontSize: "0.65rem", fontWeight: 700, color: mTokens.accent }}>{patientInitials}</Typography>
                    </Box>
                    <Typography sx={{ fontSize: "0.88rem", color: mTokens.textPrimary, fontWeight: 600 }}>{order?.patientName || order?.orderInfo?.patient || "—"}</Typography>
                  </Box>
                </Box>
                {order?.productCategory && order?.productCategory !== PRODUCT_CATEGORY.CONSERVATIVE && (
                  <InfoRow label="Product" value={`${order?.productName} (${order?.manufacturerName})`} />
                )}
                {(order?.manufacturerPatientId || mfrPatientId) && (
                  <InfoRow label="Manufacturer ID" value={order?.manufacturerPatientId || mfrPatientId} />
                )}
                <InfoRow label="Provider" value={order?.providerName || order?.orderInfo?.provider || order?.provider ||  "—"} />
                <InfoRow label="Practice" value={order?.practiceName || "—"} />
                {order?.ivrNumber && order?.ivrId && (
                  <InfoRow
                    label="IVR ID"
                    value={
                      <Link component="button" underline="hover" onClick={() => navigate("/ivr_list", { state: { ivrNumber: order?.ivrNumber } })} sx={{ color: "#42A5F5", fontWeight: 600, fontSize: "0.85rem" }}>
                        {order?.ivrNumber}
                      </Link>
                    }
                  />
                )}
                <InfoRow
                  label="Order ID"
                  value={
                    <Box display="flex" alignItems="center" gap={0.5}>
                      <span>{order?.orderNumber || "—"}</span>
                      {order?.isUpfrontOrder && <BoltOutlined sx={{ fontSize: 18, color: "#00E5B0" }} titleAccess="Upfront Order" />}
                    </Box>
                  }
                />
                {order?.manufacturerOrderId && (
                  <InfoRow label="MFR. Order ID" value={order.manufacturerOrderId} />
                )}
                {(isEditing || order?.poNumber || getValues("po")) && (
                  <InfoRow
                    label="PO (if applicable)"
                    value={
                      isEditing ? renderPoNumberComponent() : order?.poNumber || getValues("po") ? (
                        <Tooltip title="Click to edit" placement="top" arrow>
                          <Typography component="span" onClick={handleEditClick} sx={{ cursor: "pointer", fontSize: "0.85rem", fontWeight: 600, color: mTokens.textPrimary, "&:hover": { color: "#38bdf8", textDecoration: "underline" } }}>
                            {order?.poNumber || getValues("po")}
                          </Typography>
                        </Tooltip>
                      ) : (
                        <Tooltip title="Click to add PO#" placement="top" arrow>
                          <Typography component="span" onClick={handleEditClick} sx={{ cursor: "pointer", fontSize: "0.85rem", color: mTokens.textSecondary, "&:hover": { textDecoration: "underline" } }}>
                            —
                          </Typography>
                        </Tooltip>
                      )
                    }
                  />
                )}
                <InfoRow
                  label="Date of Service"
                  value={order?.dateOfService ? (
                    <Box display="flex" alignItems="center" gap={0.5}>
                      <CalendarTodayOutlined sx={{ fontSize: "0.85rem", color: mTokens.textSecondary }} />
                      <span>{order.dateOfService}</span>
                    </Box>
                  ) : "—"}
                />
                {order?.additionalNotes && (
                  <InfoRow
                    label="Additional Notes"
                    value={
                      <Tooltip title="Show Notes" placement="top" arrow>
                        <span style={{ cursor: "pointer" }} onClick={() => { if (order?.additionalNotes) showCustomCommentPopupFromOrderForm(order); }}>
                          <CommentOutlined fontSize="small" sx={{ color: mTokens.accent }} />
                        </span>
                      </Tooltip>
                    }
                  />
                )}
              </Box>
            </Box>

            {/* Order Summary card */}
            {canViewCOGSPrice &&
            <Box sx={{ ...sectionCardSx, flexShrink: 0, marginBottom : {xs : 5, md :2} }}>
              <SectionHeader icon={<ReceiptLongOutlined fontSize="small" />} title="Order Summary" />
              <Box sx={{ px: 2.8, pt: 0.5, pb: 2 }}>
                {canViewCOGSPrice && orderAmountsBreakdown && (
                  <>
                    <Box display="flex" alignItems="center" justifyContent="space-between" py={0.5} sx={{ borderBottom: `1px solid ${mTokens.border}` }}>
                      <Typography sx={{ fontSize: "0.82rem", color: mTokens.textSecondary }}>Subtotal</Typography>
                      <Typography sx={{ fontSize: "0.88rem", color: mTokens.textPrimary, fontWeight: 500 }}>
                        {priceFormatter(orderAmountsBreakdown.extendedSubtotal)}
                      </Typography>
                    </Box>
                    {orderAmountsBreakdown.shippingCharges > 0 && (
                      <Box display="flex" alignItems="center" justifyContent="space-between" py={0.5} sx={{ borderBottom: `1px solid ${mTokens.border}` }}>
                        <Typography sx={{ fontSize: "0.82rem", color: mTokens.textSecondary }}>Shipping</Typography>
                        <Typography sx={{ fontSize: "0.88rem", color: mTokens.textPrimary, fontWeight: 500 }}>
                          {priceFormatter(orderAmountsBreakdown.shippingCharges)}
                        </Typography>
                      </Box>
                    )}
                    {orderAmountsBreakdown.discountAmount > 0 && (
                      <Box display="flex" alignItems="center" justifyContent="space-between" py={0.5} sx={{ borderBottom: `1px solid ${mTokens.border}` }}>
                        <Typography sx={{ fontSize: "0.82rem", color: mTokens.textSecondary }}>
                          Discount{orderAmountsBreakdown.discountPercent ? ` (${orderAmountsBreakdown.discountPercent}%)` : ""}
                        </Typography>
                        <Typography sx={{ fontSize: "0.88rem", color: "#dc3545", fontWeight: 500 }}>
                          -{priceFormatter(orderAmountsBreakdown.discountAmount)}
                        </Typography>
                      </Box>
                    )}
                    <Box display="flex" alignItems="center" justifyContent="space-between" py={0.5}>
                      <Typography sx={{ fontSize: "0.9rem", color: mTokens.textPrimary, fontWeight: 700 }}>Total</Typography>
                      <Typography sx={{ fontSize: "0.9rem", color: mTokens.textPrimary, fontWeight: 800 }}>
                        {priceFormatter(Number(orderAmountsBreakdown.total ?? OrderObject?.orderTotalPrice ?? order?.orderTotalPrice ?? 0))}
                      </Typography>
                    </Box>
                    {(OrderObject ?? order)?.isUpfrontOrder && (
                      <Box pt={0.3} pb={0.5}><UpfrontOrderDetailsNote /></Box>
                    )}
                  </>
                )}
                {canViewCOGSPrice && !orderAmountsBreakdown && (
                  <Box display="flex" alignItems="center" justifyContent="space-between" py={0.6}>
                    <Typography sx={{ fontSize: "0.9rem", color: mTokens.textPrimary, fontWeight: 700 }}>Total</Typography>
                    <Typography sx={{ fontSize: "0.9rem", color: mTokens.textPrimary, fontWeight: 800 }}>
                      {priceFormatter(Number(OrderObject?.orderTotalPrice ?? order?.orderTotalPrice ?? 0))}
                    </Typography>
                  </Box>
                )}
              </Box>
            </Box>
            }
          </Box>{/* end right column */}

        </Box>{/* end two-column grid */}

      </Box>{/* end main content */}

      <CustomCommentPopup
        open={showCommentPopup}
        onClose={hideCustomCommentPopup}
        title={commentData.title}
        commentBody={commentData.body}
      />
      <ReturnAuditPopup
        open={showReturnPopup}
        onClose={() => setShowReturnPopup(false)}
        data={returnAuditData}
      />
      <ShipmentInfoPopup
        open={shipmentInfoOpen}
        onClose={() => setShipmentInfoOpen(false)}
        trackingNumber={order?.trackingNumber || ""}
        orderId={order?.orderId || 0}
        orderNumber={order?.orderNumber || "-"}
        shipper={{
          city: trackingData?.shipping_info?.shipper_address?.city || "",
          state: trackingData?.shipping_info?.shipper_address?.state || "",
          postal_code: trackingData?.shipping_info?.shipper_address?.postal_code || "",
        }}
        recipient={{
          city: trackingData?.shipping_info?.recipient_address?.city || "",
          state: trackingData?.shipping_info?.recipient_address?.state || "",
          postal_code: trackingData?.shipping_info?.recipient_address?.postal_code || "",
        }}
        status={orderTrackingLogs?.status || ""}
        carrierName={orderTrackingLogs?.carrier || ""}
        shippingDate={shippingDate}
        departureTime={departureTime}
        expectedArrival={orderTrackingLogs?.status === "Delivered" ? actualDeliveryTime : expectedArrivalFrom !== "N/A" && expectedArrivalTo !== "N/A" ? expectedArrivalFrom + " - " + expectedArrivalTo : expectedArrivalFrom !== "N/A" ? expectedArrivalFrom : expectedArrivalTo}
        events={scanEvents}
        milestones={dateAndTimes.map((d: any) => d.type)}
      />
      <ExcelDetailsPopup onClose={() => setShowExcelPopup(false)} open={showExcelPopup} rows={SalesDetailsInfo} />
      {isConfirmationOpen && (
        <OptionsPopup
          open={isConfirmationOpen}
          onClose={() => handleCloseCancelOrderConfirmation()}
          variant="confirm"
          message="Do you really want to cancel this order?"
          buttons={[
            { name: "Confirm", color: "primary", onClick: () => handleCancelOrderConfirmation() },
            { name: "Cancel", color: "secondary", onClick: () => setIsConfirmationOpen(false) },
          ]}
        />
      )}
      {showSignOrderPopup && (
        <SignOrderPopup
          open={showSignOrderPopup}
          onClose={() => { setShowSignOrderPopup(false); }}
          orderData={order}
        />
      )}
      <EditOrderAmountPopup
        open={showEditAmountPopup}
        handleClose={() => setShowEditAmountPopup(false)}
        orderItems={orderItemsListInfo || []}
        onUpdate={(payload: OrderItemsPriceUpdateRequest) => { handleUpdateOrderItemPrice(payload); }}
      />
    </Box>
  );
};

export default Details;
